// vim: tabstop=2:shiftwidth=2:expandtab:
import 'ol/ol.css';
import Draw from 'ol/interaction/Draw';
import {toStringHDMS} from 'ol/coordinate';
import Feature from 'ol/Feature';
import Geolocation from 'ol/Geolocation';
import Map from 'ol/Map';
import {Circle, Point, LineString} from 'ol/geom';
import View from 'ol/View';
import MVT from 'ol/format/MVT';
import TileState from 'ol/TileState';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import {Fill, Icon, Stroke, Style, Text} from 'ol/style';
import {Circle as CircleStyle} from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {OSM, TileDebug} from 'ol/source';
import BingMaps from 'ol/source/BingMaps';
import Overlay from 'ol/Overlay';
import XYZ from 'ol/source/XYZ';
import {createXYZ} from 'ol/tilegrid';
import {transformExtent, fromLonLat, getTransform, toLonLat} from 'ol/proj';
import {defaults as defaultControls, Attribution, Control, FullScreen, Rotate, ScaleLine, Zoom} from 'ol/control';
import * as olExtent from 'ol/extent';
import {DragRotate, DoubleClickZoom, DragPan, PinchRotate, PinchZoom, KeyboardPan, KeyboardZoom, MouseWheelZoom, DragZoom} from 'ol/interaction';
import { Collection } from 'ol';
import proj4 from 'proj4';
import * as ST from './superthings';
import * as FS from './featurestyles';
import {geotag_categories} from './geotag_categories';
import Target from 'ol/events/Target';
const Drawing = require('dxf-writer');


const MAPDIR_PREFIX = "/MAP";

const isIOS = navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/);


const global_NavigationalMarksUrl = 'https://nma.vta.ee/download_xml_file/XML';
const global_GpsMinimumSpeed = 0.6; // 1.0 - too fast
const global_params = new URLSearchParams(window.location.search);
const global_DirectionTimeMilliseconds = 4 * 1000;
const global_dir = global_params.get('dir');
const global_ProjectName =  global_dir.substring(global_dir.lastIndexOf('/') + 1);
let global_Project = null; // project.json contents.
let global_ProjectTransform = null;
const global_IsDebug = global_params.get('debug');
const global_IsTileDebug = global_params.get('tiledebug');
const global_IsDtmxDisabled = global_params.get('dtmxdisable');
const global_IsEditProjectEnabled = global_params.get('editproject');
const global_Geotag = global_params.get('geotag');
const global_IsPrivate = global_params.get('isprivate');
const global_ParamsFollowVessel = global_params.get('followvessel');
let global_IsDeviationTableEnabled = false;
const global_MapDirectory = (global_IsPrivate ? global_dir : MAPDIR_PREFIX);
const global_MapServerUrl =  `https://${location.hostname}:9005/`;
const global_WebSocketHost = global_params.get('websockethost');
const global_IsOperator = !!global_params.get('operator');


const DATASETVERSION_COOKIENAME = 'DatasetVersion';
let global_DatasetVersion = '1';

const USERID_COOKIENAME = 'UserId';
let global_UserId = null;

const VESSEL_MODEL_CRANE = "Crane";

let global_View = null;
let global_Map = null;
// var mapExtent = transformExtent([100.000000, 0.000000, 105.000000, 1.000000], 'EPSG:4326', 'EPSG:3857');
// TODO: load it from the Task_SHOW.geojson.
// var mapExtent = transformExtent([28.400000, 59.700000, 28.500000, 59.8000000], 'EPSG:4326', 'EPSG:3857');
const global_MapMinZoom = 1;
const global_MapMaxZoom = 19;
const global_DefaultPosition = fromLonLat([24.759844, 59.480210]); // Somewhere in the Tallinn Bay: 24.759844, 59.480210

const global_Info = document.getElementById('info');
const global_NavigationInfoCourseSpeed = document.getElementById('navigationInfoCourseSpeed');
const global_VesselList = document.getElementById('vessellist');
const global_LayerList = document.getElementById('layerlist');
const global_GeotagCategoryList = document.getElementById('geotagcategorylist');
const global_ColorInfo = document.getElementById('colorinfo');
const global_NavionicsLogo = document.getElementById('navionicslogo');
global_NavionicsLogo.src = MAPDIR_PREFIX + '/navionics_web_logo_footer_2020.png';
const global_Connected = document.getElementById('connected');
const global_Problem = document.getElementById('problem');
const ui_container_div = document.getElementById('container');
const ui_map_div = document.getElementById('map');
const ui_crane_div = document.getElementById('crane');
const ui_crane_svg = document.getElementById('svg');
const ui_crane_status_svg = document.getElementById('cranestatus');
let ui_crane_crane_svg = null;
let ui_crane_vline_svg = null;
/// A map of a part name with bottom profiles to SVG path-s.
const ui_bottom_paths = {};

const ui_cranezoom_svg_svg = document.getElementById('svgzoom');
const ui_cranezoom_svg_grid = document.getElementById('svgzoom-grid');
const ui_cranezoom_svg_group = document.getElementById('svgzoom-g');
const ui_cranezoom_svg_scale = document.getElementById('svgzoom-scale');
let ui_cranezoom_vline_svg = null;
const ui_bottomzoom_paths = {};
const ui_crane_geotag_button = document.getElementById('crane-geotag-button');
const ui_crane_upload_button = document.getElementById('crane-upload-button');
const ui_crane_upload_input = document.getElementById('crane-upload-input');
const ui_crane_geotag_div = document.getElementById('crane-geotag');
const ui_crane_geotag_width = document.getElementById("geotag-width-input");
const ui_crane_geotag_length = document.getElementById("geotag-length-input");
const ui_crane_geotag_height = document.getElementById("geotag-height-input");
const subscription_place_mark = `Project/${global_ProjectName}/Mark`;

let ui_crane_mark_place_button = null;
let ui_crane_place_block_button = null;
let ui_crane_mark_features = [];
let global_crane_mark_location = [];
let global_crane_is_mark_mode = false;
const CRANE_BLOCK_HEIGHT_KEYNAME = "crane-block-height";
const CRANE_BLOCK_WIDTH_KEYNAME = "crane-block-width";
const CRANE_BLOCK_LENGTH_KEYNAME = "crane-block-length";


const global_MyposPosition = []; // array of [time, [x, y], speed (knots), course (deg), heading (deg)]
const global_VesselTrackLengthHours = 3.0;

let ui_layer_infos = []; // Layer information.
let ui_geotag_category_infos = []; // Category information.

const deg2rad = Math.PI / 180.0;
const rad2deg = 180.0 / Math.PI;

const ms2knots = 3600.0 / 1852.0;
const knots2ms = 1852.0 / 3600.0;


function distance(p1, p2) {
  const dx = p1[0] - p2[0];
  const dy = p1[1] - p2[1];
  const r = Math.sqrt(dx*dx + dy*dy);
  return r;
}

const CLASSNAME_DISABLED_ELEMENT = "disabled-element";

function enable_control(ui_control) {
  ui_control.classList.remove(CLASSNAME_DISABLED_ELEMENT);
}

function enable_control_with_opacity(ui_control, opacity) {
  let st = ui_control.style;
  ui_control.classList.remove(CLASSNAME_DISABLED_ELEMENT);
  st.opacity = opacity;
}

function toggle_control(ui_control) {
  if (ui_control.classList.contains(CLASSNAME_DISABLED_ELEMENT)) {
    ui_control.classList.remove(CLASSNAME_DISABLED_ELEMENT);
  }
  else {
    ui_control.classList.add(CLASSNAME_DISABLED_ELEMENT);
  }
}

function is_control_enabled(ui_control) {
  return !ui_control.classList.contains(CLASSNAME_DISABLED_ELEMENT);
}

function disable_control(ui_control) {
  ui_control.classList.add(CLASSNAME_DISABLED_ELEMENT);
}

// Clear an UI control.
function clear_control(ui_control) {
  while(ui_control.firstChild) {
      ui_control.removeChild(ui_control.firstChild);
  }
}

// Get style from the given selector name.
// Returns null when none found.
// TODO: shall we return a list of styles?
function get_style_by_selector(selector)
{
    for (let i_style=0; i_style<document.styleSheets.length; ++i_style) {
        const ss = document.styleSheets[i_style];
        for (let i_rule=0; i_rule<ss.cssRules.length; ++i_rule) {
            const rr = ss.cssRules[i_rule];
            if (rr.selectorText == selector) {
                return rr.style;
            }
        }
    }
    return null;
}


const SVG_DEFAULT_TRANSFORM = "scale(1,-1)";

function set_crane_crane_tilt(degrees, translate_x, translate_y) {
  const svg = ui_crane_crane_svg;
  if (svg) {
    svg.setAttribute("transform", `translate(${translate_x} ${translate_y}) ${SVG_DEFAULT_TRANSFORM} rotate(${degrees})`);
  }
}

if (global_IsEditProjectEnabled) {
  enable_control(global_Connected);
}
else {
  disable_control(global_Connected);
}

if (global_IsOperator) {
  enable_control(ui_crane_geotag_button);
  enable_control(ui_crane_upload_button);
}
else {
  disable_control(ui_crane_geotag_button);
  disable_control(ui_crane_upload_button);
}

// -------------- DEVTABLE STUFF --------------
const DEVTABLE_LENGTH = 8;
const DEVTABLE_STEP_DEG = 45;
const DEVTABLE_KEYNAME = 'DeviationTable';
const DEVTABLE_MIN_SPEED_MS = 4.0  * knots2ms;
const DEVTABLE_MAX_DIFF_DEG = 3.0;
const DEVTABLE_MAX_COURSE_DIFF_DEG = 5.0;
const DEVTABLE_DELAY_MS = 2 * 1000; // Minimum delay between devtable updates.
const DEVTABLE_MIN_LENGTH = 5;
const DEVTABLE_MAX_CORRECTION_DEG = 30;

const devtable_message_control = document.getElementById('deviationtable');
const devtable_clear_button = document.getElementById('deviationtable-clear');
const devtable_accept_button = document.getElementById('deviationtable-accept');
const devtable_cancel_button = document.getElementById('deviationtable-cancel');
const devtable_deviationtable_panel = document.getElementById('deviationtable-panel');

function devtable_new() {
  const r = [];
  for (let i=0; i<DEVTABLE_LENGTH; ++i) {
    r.push(0);
  }
  return r;
}

let devtable_last_course_deg = 0;
let devtable_compass_fixes = devtable_new();
let devtable_compass_fixes_backup = null;
let devtable_last_time_ms = null;

function speed_ms_of_events(ev0, ev1) {
  const d = distance(ev1[1], ev0[1]);
  const dt = 0.001 * (ev1[0] - ev0[0]);
  return d/dt;
}

function normalize_deg_to_positive(deg) {
  let r = deg;
  while (r<0) {
    r += 360;
  }
  while (r >= 360) {
    r -= 360;
  }
  return r;
}

function angle_deg_of_webmercator(loc0, loc1)
{
  let dx = loc1[0] - loc0[0];
  let dy = loc1[1] - loc0[1];
  let course_rad = Math.atan2(dx, dy);
  let course_deg = normalize_deg_to_positive(rad2deg * course_rad);
  return course_deg;
}

function angle_deg_of_lonlat(lonlat0, lonlat1)
{
  const wm_0 = fromLonLat(lonlat0);
  const wm_1 = fromLonLat(lonlat1);
  return angle_deg_of_webmercator(wm_0, wm_1);
}

function angle_deg_of_events(ev0, ev1) {
  let p0 = ev0[1];
  let p1 = ev1[1];
  return angle_deg_of_webmercator(p0, p1);
}

function heading_diff(h1deg, h2deg)
{
    let diff = h2deg - h1deg;
    while (diff>180) {
      diff -= 360;
    }
    while (diff<-180) {
      diff += 360;
    }
    return diff;
}

function devtable_set_message(text) {
  if (devtable_message_control == null) {
    return;
  }
  devtable_message_control.innerText = text;
}

function pad_left_nbsp(s) {
  const l = s.length;
  if (l == 3) {
    return s;
  }
  if (l == 2) {
    return '_' + s;
  }
  if (l == 1) {
    return '__' + s;
  }
  return l;
}

function devtable_as_lines(active_index, active_text) {
  let sv = devtable_compass_fixes.map((a,index) => {
    const s = `${pad_left_nbsp((index * DEVTABLE_STEP_DEG).toFixed(0))} ${a.toFixed(1)}`;
    if (active_index===undefined || active_text===undefined || active_index!=index) {
      return s;
    }
    return s + ' ' + active_text;
  });
  let r = sv.join('\n');
  return r;
}

function devtable_is_clear() {
  for (let i=0; i<DEVTABLE_LENGTH; ++i) {
    if (Math.abs(devtable_compass_fixes[i])>0.01) {
      return false;
    }
  }
  return true;
}

function devtable_clear() {
  for (let i=0; i<DEVTABLE_LENGTH; ++i) {
    devtable_compass_fixes[i] = 0;
  }
}

function devtable_show() {
  enable_control_with_opacity(devtable_deviationtable_panel, 1);
  devtable_set_message('Devtable: \n' + devtable_as_lines(undefined, undefined));
}

function devtable_hide() {
  disable_control(devtable_deviationtable_panel);
  global_IsDeviationTableEnabled = false;
  if (global_MyposPosition.length>0) {
    const pos = global_MyposPosition[global_MyposPosition.length - 1][1];
    const null_line = [pos, pos];
    global_MyCourseArrowFeature.setGeometry(new LineString(null_line));
    global_MyCompassArrowFeature.setGeometry(new LineString(null_line));
  }
}

function devtable_init() {
  if (devtable_deviationtable_panel != null) {
    let st = devtable_deviationtable_panel.style;
    if (global_IsDeviationTableEnabled) {
      devtable_show();
    }
    else {
      devtable_hide();
    }
  }

  let devtable_json = localStorage.getItem(DEVTABLE_KEYNAME);
  if (devtable_json) {
    devtable_compass_fixes = JSON.parse(devtable_json);
  }
  // devtable_compass_fixes = [-10, -10, 0, 0,   0, 0, 0, 0];   // FIXME: comment this line out.
  devtable_set_message('Devtable: \n' + devtable_as_lines());

  devtable_clear_button.addEventListener('click', ev => {
    devtable_clear();
    devtable_set_message('Devtable: \n' + devtable_as_lines());
  });
  devtable_accept_button.addEventListener('click', ev => {
    localStorage.setItem(DEVTABLE_KEYNAME, JSON.stringify(devtable_compass_fixes));
    devtable_hide();
  });
  devtable_cancel_button.addEventListener('click', ev => {
    devtable_compass_fixes = [...devtable_compass_fixes_backup];
    devtable_hide();
  });
}

function mix_angles(f1,deg1,f2,deg2) {
  const deg12 = heading_diff(deg1, deg2);
  const r_deg = deg1 + f2 * deg12;
  const r = normalize_deg_to_positive(r_deg);
  return r;
}

function average_angles(deg1, deg2) {
  const deg12 = heading_diff(deg1, deg2);
  const r_deg = deg1 + 0.5 * deg12;
  const r = normalize_deg_to_positive(r_deg);
  return r;
}

function devtable_apply_correction(deg) {
  const mag_deg = normalize_deg_to_positive(deg);
  for (let index = 0; index<DEVTABLE_LENGTH; ++index) {
    const index1 = index;
    const deg1 = index1 * DEVTABLE_STEP_DEG - devtable_compass_fixes[index1];
    const index2 = (index + 1) % DEVTABLE_LENGTH;
    const deg2 = index2 * DEVTABLE_STEP_DEG - devtable_compass_fixes[index2];
    const deg_range = heading_diff(deg1, deg2); // this must be always positive.
    const ofs1 = heading_diff(deg1, mag_deg);
    if (ofs1 < 0 || ofs1 > deg_range) {
      continue;
    }
    const ofs2 = heading_diff(mag_deg, deg2);
    if (ofs2 < 0 || ofs2 > deg_range) {
      continue;
    }
    const new_deg = (index1 + ofs1/deg_range) * DEVTABLE_STEP_DEG;
    return new_deg;
  }
  return deg; // Shall never get here :)
}

function devtable_string_of_bool(x) {
  return x ? 'T' : 'f';
}

function devtable_process(now_ms) {
  const HEADING_INDEX = 4;
  const N1 = DEVTABLE_MIN_LENGTH - 1;
  if (global_MyposPosition.length<DEVTABLE_MIN_LENGTH) {
    return;
  }
  const is_delay_ok = devtable_last_time_ms==null || (now_ms - devtable_last_time_ms) >= DEVTABLE_DELAY_MS;
  if (!(devtable_last_time_ms==null || (now_ms - devtable_last_time_ms) >= (1 * 1000))) {
    return;
  }

  const mypos_offset = global_MyposPosition.length - DEVTABLE_MIN_LENGTH;
  const mypos_first = global_MyposPosition[mypos_offset];
  const mypos_last = global_MyposPosition[global_MyposPosition.length - 1];
  
  const speed_global = speed_ms_of_events(mypos_first, mypos_last);
  let is_speed_ok =  speed_global >= DEVTABLE_MIN_SPEED_MS;
  for (let i=0; i<N1; ++i) {
    const this_speed = speed_ms_of_events(global_MyposPosition[mypos_offset + i], global_MyposPosition[mypos_offset + i + 1]);
    const this_speed_ok = this_speed >= DEVTABLE_MIN_SPEED_MS;
    if (!this_speed_ok) {
      is_speed_ok = false;
    }
  }
  
  const heading_global = average_angles(mypos_first[HEADING_INDEX], mypos_last[HEADING_INDEX]);
  const heading_global_diff = heading_diff(mypos_first[HEADING_INDEX], mypos_last[HEADING_INDEX]);
  let is_hdiff_ok = Math.abs(heading_global_diff) <= DEVTABLE_MAX_DIFF_DEG;
  for (let i=0; i<DEVTABLE_MIN_LENGTH; ++i) {
    const this_diff = heading_diff(heading_global, global_MyposPosition[mypos_offset + i][HEADING_INDEX]);
    const is_this_ok = Math.abs(this_diff) <= 2 * DEVTABLE_MAX_DIFF_DEG;
    if (!is_this_ok) {
      is_hdiff_ok = false;
    }
  }

  let course_global = angle_deg_of_events(mypos_first, mypos_last);
  let is_xdiff_ok = true;
  for (let i=0; i<N1; ++i) {
    const this_angle = angle_deg_of_events(global_MyposPosition[mypos_offset + i], global_MyposPosition[mypos_offset + i + 1]);
    const this_diff = heading_diff(course_global, this_angle);
    const is_this_ok = Math.abs(this_diff) <= DEVTABLE_MAX_COURSE_DIFF_DEG;
    if (!is_this_ok) {
      is_xdiff_ok = false;
    }
  }

  const is_all_zero = devtable_is_clear();
  const original_angle_deg = heading_global; // Angle for the original compass value.
  const course_deg = course_global; // Angle for the course correction.
  devtable_last_course_deg = course_deg;
  const index = Math.floor((normalize_deg_to_positive(course_deg) + DEVTABLE_STEP_DEG/2) / DEVTABLE_STEP_DEG) % DEVTABLE_LENGTH;
  const correction_deg = heading_diff(original_angle_deg, course_deg);
  const corrected_angle_deg = devtable_apply_correction(original_angle_deg);

  const is_magnitude_ok = Math.abs(correction_deg) <= DEVTABLE_MAX_CORRECTION_DEG;
  const in_parenthises = !is_speed_ok || !is_magnitude_ok;
  const s_correction = correction_deg.toFixed(1);
  const s_text =
    (is_hdiff_ok ? 'h' : 'H') +
    (is_xdiff_ok ? 'c' : 'C') +
    ' ' +
    (in_parenthises ? '(' + s_correction + ')' : s_correction);
    devtable_set_message('Devtable: \n' + devtable_as_lines(index, s_text));
  
  if (!is_delay_ok || !is_speed_ok || !is_hdiff_ok || !is_xdiff_ok || !is_magnitude_ok) {
    return;
  }
  
  devtable_compass_fixes[index] = correction_deg; // Shall we set all values?
  devtable_last_time_ms = now_ms;
}

devtable_init();

const global_GeoJSON = new GeoJSON();
const fetch_geojson_async = (path) => fetch(path).then(result => result.json()).then(json => global_GeoJSON.readFeatures(json));

const global_MyposStyle = new Style({
  image: new CircleStyle({
    radius: 12,
    fill: new Fill({color: 'yellow'}),
    stroke: new Stroke({
      color: 'black', width: 2
    })
  }),
  stroke: new Stroke({
    color: '#303030',
    width: 6
  })
});
const global_MyposStyle2 = new Style({
  stroke: new Stroke({
    color: 'yellow',
    width: 2
  })
});


const global_MyCourseStyle = new Style({
  image: new CircleStyle({
    radius: 12,
    fill: new Fill({color: 'green'}),
    stroke: new Stroke({
      color: 'green', width: 2
    })
  }),
  stroke: new Stroke({
    color: 'green',
    width: 6
  })
});

const global_MyCompassStyle = new Style({
  image: new CircleStyle({
    radius: 12,
    fill: new Fill({color: 'blue'}),
    stroke: new Stroke({
      color: 'blue', width: 2
    })
  }),
  stroke: new Stroke({
    color: 'blue',
    width: 6
  })
});


const global_WebuserStyle = new Style({
  image: new CircleStyle({
    radius: 12,
    fill: new Fill({color: 'red'}),
    stroke: new Stroke({
      color: 'black', width: 2
    })
  }),
  stroke: new Stroke({
    color: '#303030',
    width: 6
  })
});


let global_MyposTrackEnable = false;
let global_VesselNameToTrack = null;
let global_MyposRotation = 0;
let global_MyposSpeed = 0.0;
let global_MyposSpeedFiltered = 0.0;
let global_MyposFastEnough = false;
let global_MyposCount = 0;
let global_CompassHeadingDeg = null;

let global_FollowMeButton = null;
let global_AppendTrackEnable = false;
let global_AppendTrackButton = null;
let global_LayerListButton = null;
let satelliteLayer = null;
let seamapLayer = null;
let aerophotoEstoniaLayer = null;

// Fake mypos
let global_FakeMyposEnabled = false;
let global_FakeMyPosSpeedIncrease = 0;
let global_FakeMyposCount = 0;
let global_FakeMyposTimer = null;
let global_FakeMyposDirectionRad = 10 * Math.PI / 180;
let global_FakeMyposSpeed = 0.1;
let global_FakeMyposAcceleration = 0.1; // or -1


const global_MyposCenterFeature = new Feature({
  geometry: new Point([0, 0]),
});
const global_MyposArrowFeature = new Feature({
  geometry: new LineString([[0, 0], [0, 0]])
});
const global_MyposArrow2Feature = new Feature({
  geometry: new LineString([[0, 0], [0, 0]])
});

const global_MyCourseArrowFeature = new Feature({
  geometry: new LineString([[0, 0], [0, 0]])
});
const global_MyCompassArrowFeature = new Feature({
  geometry: new LineString([[0, 0], [0, 0]])
});

const const_MyposArrowLength = 0.45; // part of the height.

/// Ourselves.
const global_VectorOverlaySource = new VectorSource({ features : [global_MyposCenterFeature, global_MyposArrowFeature, global_MyposArrow2Feature, global_MyCourseArrowFeature, global_MyCompassArrowFeature] });

const global_MyTracks = new ST.MyTracks(global_VectorOverlaySource, localStorage);

/// Source for the depth points.
let global_DepthPointsSource = null;

/// Other vessels.
const global_VesselsSource = new VectorSource();
const global_VesselsTracksSource = new VectorSource();

// Vessel name => {
//     Parts => {
//            Heading name => { geojsonFile, features, geometries, Heading?, }
//     },
//     Position?
let global_Vessels = {};

// WebUserId => {
//      Features
//      Geometries
//
let global_WebUsers = {};


/// Seamarks
const global_SeamarksSource = new VectorSource();
let global_SeamarkDrawings = {}
const global_Seamarks = [];

const global_RocksSource = new VectorSource();
const global_RockMuster = (new GeoJSON()).readFeatures({
  "type": "FeatureCollection",
  "name": "entities",
  "features": [
    {
      "type": "Feature",
      "properties": { "Layer": "0" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [ -1.0, -0.15 ],
          [ -0.15, -0.15 ],
          [ -0.15,  -1 ],
          [ 0.15,  -1 ],
          [ 0.15,  -0.15 ],
          [ 1,  -0.15 ],
          [ 1,  0.15 ],
          [ 0.15,  0.15 ],
          [ 0.15,  1 ],
          [ -0.15,  1 ],
          [ -0.15,  0.15 ],
          [ -1, 0.15 ],
          [ -1, -0.15 ]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": { "Layer": "0" },
      "geometry": {
        "type": "Point",
        "coordinates": [ 0.3, -0.3 ]
      }
    }
  ]
});
let global_Rocks = []; // array of { local location:[x,y], features:features[]}

const global_GeotagsSource = new VectorSource();
let global_SelectedGeotagName = null;
let global_GeotagNameToChange = null;
let global_Geotags = {};
const global_GeotagsDraw = new Draw({
  source: global_GeotagsSource,
  type: 'Polygon'
});
global_GeotagsDraw.setActive(false);

/// Name of the selected vessel.
let global_SelectedVesselName = null;
/// Text element of the selected vessel.
let global_SelectedVesselText = null;

/// Definition for the Estonian coordinate system.
proj4.defs('EPSG:3301', '+proj=lcc +lat_1=59.33333333333334 +lat_2=58 +lat_0=57.51755393055556 +lon_0=24 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
proj4.defs("EPSG:3346","+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs");
proj4.defs("EPSG:32634","+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs +type=crs");

/// Get the next dataset version.
function getNextDatasetVersion() {
  const x = ST.getCookie(DATASETVERSION_COOKIENAME);
  if (x != '') {
    global_DatasetVersion = (Number(x) + 1).toString();
  }
  ST.setCookie(DATASETVERSION_COOKIENAME, global_DatasetVersion);
  return global_DatasetVersion;
}
global_DatasetVersion = getNextDatasetVersion();

// Get the user ID, if any.
global_UserId = localStorage.getItem(USERID_COOKIENAME);
if (!global_UserId || global_UserId=='') {
  // Problem: the user ID is lost when it is stored in the cookies alone.
  // Let's keep the user ID both in the cookies and in the localStorage.
  global_UserId = ST.getCookie(USERID_COOKIENAME);
  if (global_UserId == '' || global_UserId.indexOf('.')>=0) {
    global_UserId = Math.floor(Date.now()).toString();
    ST.setCookie(USERID_COOKIENAME, global_UserId);
  }
  localStorage.setItem(USERID_COOKIENAME, global_UserId);
}

function get_item_or_default(keyname, defaultValue) {
  let r = localStorage.getItem(keyname);
  return r==null ? defaultValue : r;
}

function get_bool_or_default(keyname, defaultValue) {
  let r = localStorage.getItem(keyname);
  if (r == null) {
    return defaultValue;
  }
  return r != "false";
}

function get_float_or_default(keyname, defaultValue) {
  let s = localStorage.getItem(keyname);
  if (s == null) {
    return defaultValue;
  }
  let r = parseFloat(s);
  if (isNaN(r)) {
    if (s == 'NaN') {
      return r;
    }
    return defaultValue;
  }
  return r;
}

const USERNAME_KEYNAME = 'UserName';
let global_UserName = get_item_or_default(USERNAME_KEYNAME, '');
const ISSHARING_KEYNAME = 'IsSharing';
let global_IsSharing = get_bool_or_default(ISSHARING_KEYNAME, false);


const global_LoginMessage = {
    ProjectName : global_ProjectName,
    ProjectDirectory : global_dir,
    UserId : global_UserId,
    UserName : global_UserName,
    IsSharing : global_IsSharing
  };

const ISCOMPASSENABLED_KEYNAME = 'IsCompassEnabled';
let global_IsCompassEnabled = get_bool_or_default(ISCOMPASSENABLED_KEYNAME, false);

const websocketcomm = new ST.JsonWebsocket( {
  serverUrl: `wss://${global_WebSocketHost ? global_WebSocketHost : location.hostname}:9005/`,
  loginMessage: {
    Login : global_LoginMessage,
    ListAllRocks: true,
    Subscribe: subscription_place_mark
  },
  reconnectTimeSec: 5
});

const COMPASSPATCH_REVERSE_KEYNAME = 'CompassPatch.Reverse';
let global_CompassPatchReverse = get_bool_or_default(COMPASSPATCH_REVERSE_KEYNAME);

const COMPASSPATCH_OFFSET_KEYNAME = 'CompassPatch.Offset';
let global_CompassPatchOffsetDeg = get_float_or_default(COMPASSPATCH_OFFSET_KEYNAME, 0.0);

function sendToServer(obj)
{
  websocketcomm.sendMessage(obj);
}

function consolelog(message) {
  websocketcomm.log(message);
}

function LonLatToScale(lonlat) {
  const scale = 1.0 / Math.cos(lonlat[1] * deg2rad);
  return scale;
}

function showNavigationInfoCourseSpeed(heading_deg, course_on_ground_deg, speed_knots)
{
    // Navigation info for the vessel.
    let navi_first_line = null;
    if (heading_deg != null) {
      navi_first_line = heading_deg.toFixed(1);
    }
    if (navi_first_line == null && course_on_ground_deg!=null) {
      navi_first_line = course_on_ground_deg.toFixed(1);
    }
    global_NavigationInfoCourseSpeed.innerHTML = `${navi_first_line==null ? '' : navi_first_line}<br/>${speed_knots==null ? '' : speed_knots.toFixed(1)}`;
    enable_control(global_NavigationInfoCourseSpeed);
}

function set_heading_ui(heading_deg)
{
  if (global_MyposPosition.length <= 0) {
    return;
  }
  
  const res = global_View.getResolution();
  const client_height = global_Map.getViewport().clientHeight;
  const res_mul_height = client_height * res;
  const center_offset = 0.2; // this is from the center of the screen.

  const last_mypos = global_MyposPosition[global_MyposPosition.length-1];
  const pos = last_mypos[1];
  
  const corrected_deg = devtable_apply_correction(heading_deg);
  const heading_rad = deg2rad * corrected_deg;
  const arrow_length = res_mul_height * const_MyposArrowLength;
  const ddx = Math.sin(heading_rad);
  const ddy = Math.cos(heading_rad);
  const x2 = pos[0] + arrow_length * ddx;
  const y2 = pos[1] + arrow_length * ddy;

  const line_coordinates = [pos, [x2, y2]];
  const view_x = pos[0] + res_mul_height * ddx * center_offset;
  const view_y = pos[1] + res_mul_height * ddy * center_offset;
  
  global_MyposArrowFeature.setGeometry(new LineString(line_coordinates));
  global_MyposArrow2Feature.setGeometry(new LineString(line_coordinates));

  if (global_IsDeviationTableEnabled) {
    const compass_line = coordinates_for_arrow(pos, heading_deg, (1.0 / 2.0) * arrow_length);
    global_MyCompassArrowFeature.setGeometry(new LineString(compass_line));
  }
}

function coordinates_for_arrow(pos, heading_deg, arrow_length)
{
  const heading_rad = deg2rad * heading_deg;
  const ddx = Math.sin(heading_rad);
  const ddy = Math.cos(heading_rad);
  const x2 = pos[0] + arrow_length * ddx;
  const y2 = pos[1] + arrow_length * ddy;
  const r = [pos, [x2, y2]];
  return r;
}

function get_vessel_location(vessel) {
  let vessel_position = vessel.Position;
  if (vessel_position) {
    return vessel_position;
  }
  const part_name = vessel.BackupPositionPartName;
  if (!part_name) {
    return null;
  }
  const part = vessel.Parts[part_name];
  if (!part) {
    return null;
  }
  return part.Location;
}

function set_ui_center_by_vessel(vessel)
{
  let vessel_position = get_vessel_location(vessel);
  if (vessel_position) {
    const vessel_cop = vessel.CenterOnPart;
    if (vessel_cop && vessel_cop in vessel.Parts) {
      const cop = vessel.Parts[vessel_cop];
      if (cop.Location) {
        vessel_position = cop.Location;
      }
    }
    const viewport = global_Map.getViewport();
    const is_offset_needed = global_View.viewportSize_[0] > viewport.clientWidth;
    const client_width = viewport.clientWidth;
    const res = global_View.getResolution();
    const zoom = global_View.getZoom();
    const is_crane = vessel.Model == VESSEL_MODEL_CRANE;
    const offset_x = is_crane && is_offset_needed ? res * client_width / 2 : 0;
    const scale = LonLatToScale(vessel_position);
    const pwm = fromLonLat(vessel_position);
    global_SetCenterRequests.push([pwm[0] + offset_x, pwm[1]]);
  }
}

let set_ui_to_mypos_count = 0;

// Set the UI elements according to my position.
function set_ui_to_mypos() {
  const mypos_length = global_MyposPosition.length;
  if (mypos_length >= 1) {
    ++set_ui_to_mypos_count;

    // Pointer update.
    const last_mypos = global_MyposPosition[mypos_length-1];
    const pos = last_mypos[1];
    const last_speed_knots = last_mypos[2];
    const last_course_deg = last_mypos[3];
    const last_heading_deg = last_mypos[4];

    // const fast_enough = global_MyposSpeed && global_MyposSpeed >= global_GpsMinimumSpeed;
    let fast_enough = true;
    global_MyposFastEnough = fast_enough;
    // Arrow update when fast enough.
    let arrow_dx = 0;
    let arrow_dy = 0;
    let center_dx = 0;
    let center_dy = 0;
    const res = global_View.getResolution();
    const client_height = global_Map.getViewport().clientHeight;
    const res_mul_height = client_height * res;
    const center_offset = 0.2; // this is from the center of the screen.
    let direction_rad = 0;
    const p_old = global_MyposPosition[0][1];
    const p_new = pos;
    const dx = p_new[0] - p_old[0];
    const dy = p_new[1] - p_old[1];
    const dlength = Math.sqrt(dx*dx + dy*dy);
    if (fast_enough) {
      fast_enough = dlength > 0.001;
    }
    if (global_MyposPosition.length>1) {
      const ddx = dlength > 0.001 ? dx / dlength : 0;
      const ddy = dlength > 0.001 ? dy / dlength : 0;
      direction_rad = Math.atan2(dy, dx) - Math.PI/2;
      if (fast_enough) {
        global_MyposRotation = direction_rad;
        arrow_dx = res_mul_height * ddx * const_MyposArrowLength;
        arrow_dy = res_mul_height * ddy * const_MyposArrowLength;
        center_dx = res_mul_height * ddx * center_offset;
        center_dy = res_mul_height * ddy * center_offset;
      }
    }
    if (!fast_enough) {
      const ar = global_View.getRotation() + Math.PI/2;
      center_dx = res_mul_height * Math.cos(ar) * center_offset;
      center_dy = res_mul_height * Math.sin(ar) * center_offset;
    }
    global_MyposCenterFeature.setGeometry(new Point(pos));
    let line_coordinates = [pos, [pos[0]+arrow_dx, pos[1]+arrow_dy]];
    let view_x = pos[0] + center_dx;
    let view_y = pos[1] + center_dy;
    const arrow_length = res_mul_height * const_MyposArrowLength;
    if (last_heading_deg != null && (global_IsDeviationTableEnabled || global_IsCompassEnabled)) {
      const corrected_deg = devtable_apply_correction(last_heading_deg);
      const heading_rad = deg2rad * corrected_deg;
      const ddx = Math.sin(heading_rad);
      const ddy = Math.cos(heading_rad);
      const x2 = pos[0] + arrow_length * ddx;
      const y2 = pos[1] + arrow_length * ddy;

      line_coordinates = [pos, [x2, y2]];
      view_x = pos[0] + res_mul_height * ddx * center_offset;
      view_y = pos[1] + res_mul_height * ddy * center_offset;
        
      if (global_IsDeviationTableEnabled) {
        const this_course_deg = angle_deg_of_events(global_MyposPosition[mypos_length - 2], global_MyposPosition[mypos_length - 1]);
        const course_line = coordinates_for_arrow(pos, this_course_deg, (3.0 / 4.0) * arrow_length);
        global_MyCourseArrowFeature.setGeometry(new LineString(course_line));
      }
    }
    else {
      // remains as it was.
      // line_coordinates = coordinates_for_arrow(pos, last_course_deg, arrow_length);
    }
    global_MyposArrowFeature.setGeometry(new LineString(line_coordinates));
    global_MyposArrow2Feature.setGeometry(new LineString(line_coordinates));
    
    // View update when fast enough.
    if (global_MyposTrackEnable && !global_VesselNameToTrack) {
      global_View.setCenter([view_x, view_y]);
      showNavigationInfoCourseSpeed(last_heading_deg, last_course_deg, last_speed_knots);
      if (fast_enough) {
	/* FIXME: remove rotation temporarily.
        global_View.setRotation(global_MyposRotation);
	 */
      }
    }
  }
  if (global_MyposTrackEnable && global_VesselNameToTrack) {
    let vessel = global_Vessels[global_VesselNameToTrack];
    set_ui_center_by_vessel(vessel);
  }
}

let last_compass_time_ms = Date.now()

function compass_handler(e) {
  let now = Date.now();
  let heading_deg = null;
  if ('webkitCompassHeading' in e) {
    heading_deg = e.webkitCompassHeading;
  }
  else {
    heading_deg = Math.abs(e.alpha - 360);
  }
  if (global_CompassPatchReverse) {
    heading_deg = normalize_deg_to_positive(360 - heading_deg);
  }
  heading_deg = normalize_deg_to_positive(heading_deg + global_CompassPatchOffsetDeg);
  
  global_CompassHeadingDeg = heading_deg;
  if (now-last_compass_time_ms>=200) {
    last_compass_time_ms = now;
    sendToServer({Position : {
      TimestampNetUtc: ST.getTimestampNetUtcFromMs(now),
      Heading: heading_deg
    }});
    if (global_MyposPosition.length >= 1 && (!global_MyposTrackEnable || (global_MyposTrackEnable && !global_VesselNameToTrack))) {
      const last_mypos = global_MyposPosition[global_MyposPosition.length-1];
      const pos = last_mypos[1];
      const last_speed_knots = last_mypos[2];
      const last_course_deg = last_mypos[3];
      showNavigationInfoCourseSpeed(heading_deg, last_course_deg, last_speed_knots);
      if (global_IsCompassEnabled || global_IsDeviationTableEnabled) {
        set_heading_ui(heading_deg);
      }
    }
  }
}

function alert_navigator() {
  consolelog('Navigation not available.');
  alert('Navigation not available.\nPlease check: Settings > Privacy > Location Services > Safari');
}

function createButton(parent, label, tooltip, clickHandler) {
  const button = document.createElement('button');
  button.innerText = label;
  button.title = tooltip;
  parent.appendChild(button);
  button.addEventListener('click', clickHandler, false);
  return button;
}

let create_checkbox_id = 0;

/// Create a textbox in the given container.
/// The label and the tooltip are created separately.
function createCheckbox(container, label, tooltip, changeHandler) {
  const id = `checkbox${create_checkbox_id}`;
  ++create_checkbox_id;
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.title = tooltip;
  input.id = id;
  input.addEventListener('change', changeHandler, false);
  container.appendChild(input);

  const lbl = document.createElement('label');
  lbl.htmlFor = id;
  lbl.appendChild(document.createTextNode(label));
  lbl.tooltip = tooltip;
  container.appendChild(lbl);

  return input;
}

let create_radiobutton_id = 0;

function createRadiobutton(container, name, value, label, tooltip, selectedHandler) {
  const id = `radiobutton${create_radiobutton_id}`;
  ++create_radiobutton_id;
  const input = document.createElement('input');
  input.type = 'radio';
  input.title = tooltip;
  input.id = id;
  input.name = name;
  input.value = value;
  input.addEventListener('change', selectedHandler, false);
  container.appendChild(input);

  const lbl = document.createElement('label');
  lbl.htmlFor = id;
  lbl.appendChild(document.createTextNode(label));
  lbl.tooltip = tooltip;
  container.appendChild(lbl);

  return { radio: input, label: lbl };
}

let global_EditProjectHandler = null;

function getDepthOfFeature(feature) {
  const s_depth = feature.get('depth');
  if (typeof s_depth == 'number') {
    return s_depth;
  }
  if (typeof s_depth == 'string') {
    return -1 * Number(s_depth);
  }
  // no more options.
}

const SNAP_RADIUS = 2.0;
function getCoordinatesAndZInRadius(coordinate) {
  const lonlat = toLonLat(coordinate);
  const x = coordinate[0];
  const y = coordinate[1];
  const sr = SNAP_RADIUS * LonLatToScale(lonlat);
  const extent = olExtent.boundingExtent([[x - sr, y - sr], [x + sr, y + sr]]);
  const all_features = global_DepthPointsSource.getFeaturesInExtent(extent);
  let r = [];
  for (let i=0; i<all_features.length; ++i) {
    const f = all_features[i];
    const g = f.getGeometry();
    const cf = g.getFlatCoordinates();
    const d = distance(cf, coordinate);
    if (d <= sr) {
      const c = toLonLat(cf);
      const z = getDepthOfFeature(f);
      r.push([c, z, cf]);
    }
  }
  return r;
}

function editProjectAddRockClick(event, coordinates, features) {
  const c = event.coordinate;
  const results = getCoordinatesAndZInRadius(c);
  if (results.length==0) {
    return;
  }
  const r_sorted = results.sort(function(a,b) {
    const za = a[1];
    const zb = b[1];
    if (za>zb) {
      return -1;
    }
    if (za<zb) {
      return 1;
    }
    return 0;
  });
  const dp = r_sorted[0];
  consolelog(`editProjectAddRock: ${dp}`);
  sendToServer({ AddRock: {
    TimestampNetUtc: ST.getTimestampNetUtc(),
    Name: 'Rock',
    Location: dp[0],
    Z: dp[1]
  }});
}

function editProjectAddRockHereClick(event, coordinate, features) {
  const results = getCoordinatesAndZInRadius(coordinate);
  if (results.length==0) {
    return;
  }
  const r_sorted = results.sort(function(a,b) {
    const ra = distance(coordinate, a[2]);
    const rb = distance(coordinate, b[2]);
    if (ra<rb) {
      return -1;
    }
    if (ra>rb) {
      return 1;
    }
    return 0;
  });
  const dp = r_sorted[0];
  const d_min = distance(dp[2], coordinate);
  consolelog(`editProjectAddRockHere: ${dp[0]}/${dp[1]}/${dp[2]}   d_min:${d_min}`);
  sendToServer({ AddRock: {
    TimestampNetUtc: ST.getTimestampNetUtc(),
    Name: 'Rock',
    Location: dp[0],
    Z: dp[1]
  }});
}

function editProjectDeleteRockHereClick(event, coordinate, features) {
  let best_index = -1;
  let best_distance = null; 
  let best_coordinate = null;
  for (let i=0; i<global_Rocks.length; ++i) {
    const rock = global_Rocks[i];
    const d = distance(coordinate, rock.location);
    if (best_index<0 || d<best_distance) {
      best_distance = d;
      best_index = i;
      best_coordinate = rock.location;
    }
  }
  if (best_index<0) {
    return;
  }
  const best_cf = toLonLat(best_coordinate);
  consolelog(`editProjectDeleteRockHere ${best_cf}/${best_coordinate}  d_min:${best_distance}`);
  sendToServer({ DeleteRock: {
    TimestampNetUtc: ST.getTimestampNetUtc(),
    Location: best_cf
  }});
}

function editProjectAddGeotag(event, coordinate, features) {
  if (features.length>0) {
    const f0 = features[0];
    const geotagName = f0.geotagName;
    if (geotagName) {
      showGeotagInfo(geotagName);
      return;
    }
  }
  sendToServer({ AddGeotag: toLonLat(coordinate) });
}

let global_EditProjectButtons = [
  { action:editProjectAddRockClick, button:null, enableText:'R', disableText:'r'},
  { action:editProjectAddRockHereClick, button:null, enableText:'H', disableText:'h'},
  { action:editProjectDeleteRockHereClick, button:null, enableText:'D', disableText:'d'},
  { action:editProjectAddGeotag, button:null, enableText:'T', disableText:'t'},
  { action:editProjectAddGeotag, button:null, enableText:'TA', disableText:'ta', enableDraw:true}
]

function editProjectToggleButton(index) {
  for (let i=0; i<global_EditProjectButtons.length; ++i) {
    const bi = global_EditProjectButtons[i];
    const b = bi.button;
    if (i == index) {
      if (b.innerText == bi.disableText) {
        // Enable.
        global_EditProjectHandler = bi.action;
        b.innerText = bi.enableText;
        if (bi.enableDraw) {
          global_GeotagsDraw.setActive(true);
        }
      }
      else {
        global_EditProjectHandler = null;
        b.innerText = bi.disableText;
        global_GeotagsDraw.setActive(false);
      }
    }
    else {
      b.innerText = bi.disableText;
    }
  }
}

const global_FullScreen_Normal = new FullScreen();
const global_FullScreen_Crane = new FullScreen({ source: "container" });

function set_ui_to_vessel_model()
{
  // Check the UI.
  const vessel = global_VesselNameToTrack ? global_Vessels[global_VesselNameToTrack] : null;
  const is_crane = vessel && vessel.Model == VESSEL_MODEL_CRANE;
  const suffix = is_crane ? "-crane" : "";
  const map_className = `map${suffix}`;
  if (ui_map_div.className == map_className) {
    return;
  }
  if (is_crane) {
    global_Map.removeControl(global_FullScreen_Normal);
    global_Map.addControl(global_FullScreen_Crane);
  }
  else {
    global_Map.removeControl(global_FullScreen_Crane);
    global_Map.addControl(global_FullScreen_Normal);
  }
  ui_map_div.className = map_className;
  ui_crane_div.className = `crane${suffix}`;
}

/// Follow the vessel.
/// Note: The InfoDisabled flag is cleared.
function followVesselByName(vesselName) {
  global_MyposTrackEnable = true;
  global_VesselNameToTrack = vesselName;
  global_SelectedVesselName = vesselName;
  global_FollowMeButton.innerHTML = 'U';
  global_VesselList.innerHTML = '';
  // FIXME: disable_control(global_VesselList);?
  set_ui_to_mypos();
  set_ui_to_vessel_model();
  const vessel = global_Vessels[vesselName];
  if (vessel) {
    vessel.InfoDisabled = false;
  }
  showVesselInfo(vesselName);
}


function geopos_error(error) {
  const msg = 'Geopos error: ' + error.code + ', message: ' + error.message;
  alert(msg);
  consolelog(msg);
}

function geopos_success(pos) {
  const now_ms = Date.now();
  const localpos = fromLonLat([pos.coords.longitude, pos.coords.latitude]);
  handle_Mypos(now_ms, localpos, pos.coords.speed, pos.coords.heading);
}

let global_mypos_watcher = null;

function start_navigator_geolocation() {
  const options = {
    tracking: true,
    enableHighAccuracy: true,
    /*
    timeout: 20000,
    maximumAge: 0,
    distanceFilter: 0,
    desiredAccuracy: 0,
    */
  };
  global_mypos_watcher = navigator.geolocation.watchPosition(geopos_success, geopos_error, options);
}

let is_geolocation_started = false;
function start_geolocation_if_needed() {
  if (!is_geolocation_started) {
    is_geolocation_started = true;
    // Compass
    if (isIOS) {
      DeviceOrientationEvent.requestPermission()
        .then((response) => {
          if (response === "granted") {
            window.addEventListener("deviceorientation", compass_handler, true);
          }
          else {
            const msg = "Compass has to be allowed!";
            alert(msg);
            consolelog(msg);
          }
        })
        .catch(() => alert("not supported"));
    }
    else {
      window.addEventListener("deviceorientationabsolute", compass_handler, true);
    }

    // Check whether we have permissions?
    if (navigator.permissions && navigator.permissions.query) {
      //try permissions APIs first
      navigator.permissions.query({ name: 'geolocation' }).then(function(result) {
        // Will return ['granted', 'prompt', 'denied']
        const permission = result.state;
        if ( permission === 'granted' || permission === 'prompt' ) {
          consolelog('Navigation available (got info from permissions).');
          start_navigator_geolocation();
        }
        else {
          alert_navigator();
        }
      });
    } else if (navigator.geolocation) {
      //then Navigation APIs
      consolelog('Navigation available (got info from API).');
      start_navigator_geolocation();
    } else {
      alert_navigator();
    }
  }
}

function clear_crane_mark()
{
  ui_crane_mark_features.forEach(f => global_VectorOverlaySource.removeFeature(f));
  ui_crane_mark_features = [];
  global_crane_mark_location = [];
}


class LayerInfo {
  static KEYNAME = 'UI.LayerVisibility';
  static COLOR_ENABLED = 'lightgreen';
  static COLOR_DISABLED = 'pink';

  constructor(layer, label, tooltip, changeCallback) {
    this.layer = layer;
    this.label = label;
    this.tooltip = tooltip;
    this.changeCallback = changeCallback;
    this.isInitialized = false;
    this.checkbox = createCheckbox(global_LayerList, label, tooltip, this.handleChange.bind(this));
    createElementInParent(global_LayerList, 'br');
  }

	handleToggle() {
    const is_visible = !this.layer.getVisible();
    this.layer.setVisible(is_visible);
    this.button.style.background = is_visible ? LayerInfo.COLOR_ENABLED : LayerInfo.COLOR_DISABLED;
  }

  handleChange() {
    const is_visible = this.checkbox.checked;

    // 1. Navionics special.
    if (this.changeCallback) {
      this.changeCallback(is_visible);
    }

    if (!this.isInitialized) { // this is set after initialization.
      return;
    }

    // 2. Main business.
    this.layer.setVisible(is_visible);

    // 3. Store settings.
    const s_settings = localStorage.getItem(LayerInfo.KEYNAME);
    let settings = {};
    if (s_settings) {
      try {
        settings = JSON.parse(s_settings);
      }
      catch (ex) {
        consolelog(`LayerInfo.handleChange: ${ex}`);
      }
    }
    if (!settings) {
      settings = {};
    }
    settings[this.label] = is_visible;
    const new_settings = JSON.stringify(settings);
    localStorage.setItem(LayerInfo.KEYNAME, new_settings);
  }

  static refreshAll(layer_infos) {
    for (let i=0; i<layer_infos.length; ++i) {
      const ll = layer_infos[i];
      ll.isInitialized = false;
      ll.checkbox.checked = ll.layer.getVisible();
      ll.isInitialized = true;
    }
  }

  // Initialize the infos.
  // Exceptions are swallowed.
  static initAll(layer_infos) {
    try {
      let s_settings = localStorage.getItem(LayerInfo.KEYNAME);
      const settings = s_settings ? JSON.parse(s_settings) : {};
      for (let i=0; i<layer_infos.length; ++i) {
        const ll = layer_infos[i];
        if (ll.label in settings) {
          const is_visible = settings[ll.label];
          ll.layer.setVisible(is_visible);
          if (ll.changeCallback) {
            ll.changeCallback(is_visible);
          }
        }
        ll.isInitialized = true;
      }
    }
    catch (ex) {
      consolelog(`LayerInfo.initAll: ${ex}`);
    }
    for (let i=0; i<layer_infos.length; ++i) {
      layer_infos[i].isInitialized = true;
    }
  }
}

class GeotagCategoryInfo {
  constructor(name, color) {
    this.name = name;
    this.changeCallback = null;
    const space = createElementInParent(global_GeotagCategoryList, 'label');
    space.style.width = '100%';
    space.style.height = '10px';
    space.style.background = color;
    space.innerText = '  ';
    this.control = createRadiobutton(global_GeotagCategoryList, 'category', name, name, `Select ${name}`, this.handleChange.bind(this));
    const br = createElementInParent(global_GeotagCategoryList, 'br');
  }

  handleChange() {
    if (this.changeCallback && this.control.radio.checked) {
      this.changeCallback(this.name);
    }
  }

  static refreshAll(infos, category, changeCallback) {
    for (let i=0; i<infos.length; ++i) {
      const ci = infos[i];
      ci.changeCallback = null;
    }
    for (let i=0; i<infos.length; ++i) {
      const ci = infos[i];
      if (ci.name == category) {
        ci.control.radio.checked = true;
      }
    }
    for (let i=0; i<infos.length; ++i) {
      const ci = infos[i];
      ci.changeCallback = changeCallback;
    }
  }
}

class MaryMapControl extends Control {
  //
  // @param {Object} [opt_options] Control options.
  //
  constructor(opt_options) {
		const options = opt_options || {};
    // 1. Construct the object.
		const element = document.createElement('div');
    element.className = 'mary-map-control ol-unselectable ol-control';
    super({
			element: element,
			target: options.target
		});

    // 2. Add our custom elements.
    global_FollowMeButton = createButton(element, 'F', 'Follow my location', this.handleFollowMe.bind(this));
    global_AppendTrackButton = createButton(element, 'tr', 'Append Track', this.handleAppendTrack.bind(this));
    const rotate_north_button = createButton(element, 'N', 'Rotate map to north', this.handleRotateNorth.bind(this))
    global_LayerListButton = createButton(element, 'L', 'Layer list', this.toggleLayerList.bind(this));
    
    if (global_IsEditProjectEnabled) {
      global_EditProjectButtons[0].button = createButton(element, 'r', 'Add shallowest rock', this.handleAddRock.bind(this));
      global_EditProjectButtons[1].button = createButton(element, 'h', 'Add nearest rock here', this.handleAddRockHere.bind(this));
      global_EditProjectButtons[2].button = createButton(element, 'd', 'Delete nearest rock', this.handleDeleteRock.bind(this));
      global_EditProjectButtons[3].button = createButton(element, 't', 'Add geotag', this.handleAddGeotag.bind(this));
      global_EditProjectButtons[4].button = createButton(element, 'ta', 'This is experimental', this.handleAddGeotagArea.bind(this));
    }

    if (global_IsOperator) {
      ui_crane_mark_place_button = createButton(element, 'm', 'Mark a place on the map for a block', this.handleCraneSetMark.bind(this));
      ui_crane_place_block_button = createButton(element, 'p', 'Place a block on the map where the mark is', this.handleCranePlaceBlock.bind(this));
    }
	}

	handleFollowMe () {
    // Follow me logic.
		if (global_MyposTrackEnable || (!ST.isEmptyObject(global_Vessels) && global_VesselList.innerHTML!='')) {
			global_MyposTrackEnable = false;
      global_VesselNameToTrack = null;
      global_FollowMeButton.innerHTML = 'F';
      global_VesselList.innerHTML = '';
      set_ui_to_vessel_model();
		}
		else {
      if (ST.isEmptyObject(global_Vessels)) {
        global_MyposTrackEnable = true;
        global_VesselNameToTrack = null;
        global_FollowMeButton.innerHTML = 'U';
        set_ui_to_mypos();
        start_geolocation_if_needed(); // Initialize GPS and compass.
      }
      else {
        createButton(global_VesselList, 'Do not follow', 'Do not follow anybodys position', () => {
          global_MyposTrackEnable = false;
          global_VesselNameToTrack = null;
          global_FollowMeButton.innerHTML = 'F';
          global_VesselList.innerHTML = '';
          global_NavigationInfoCourseSpeed.style.innerHTML = '';
          disable_control(global_NavigationInfoCourseSpeed);
        });
        createElementInParent(global_VesselList, 'br');
        createButton(global_VesselList, 'Follow me', 'Follow my position', () => {
          global_MyposTrackEnable = true;
          global_VesselNameToTrack = null;
          global_FollowMeButton.innerHTML = 'U';
          global_VesselList.innerHTML = '';
          set_ui_to_mypos();
          start_geolocation_if_needed(); // Initialize GPS and compass.
        });
        createElementInParent(global_VesselList, 'br');
        for (let vesselName in global_Vessels) {
          createButton(global_VesselList, vesselName, `Follow vessel ${vesselName}`, () => {
            followVesselByName(vesselName);
          });
          createElementInParent(global_VesselList, 'br');
        }
        enable_control(global_VesselList);
      }
		}
    consolelog(`User: Follow my position: ${global_MyposTrackEnable}`);
	}

  handleAppendTrack () {
    if (global_AppendTrackEnable) {
      global_AppendTrackEnable = false;
      global_AppendTrackButton.innerHTML = 'tr';
      global_MyTracks.stop();
    }
    else {
      global_AppendTrackEnable = true;
      global_AppendTrackButton.innerHTML = 'TR';
      global_MyTracks.start();
      if (global_MyposPosition && global_MyposPosition.length>0) {
        const [time, pos] = global_MyposPosition[global_MyposPosition.length - 1];
        global_MyTracks.addPoint(pos);
      }
    }
  }

  handleRotateNorth () {
    consolelog('User: Rotate to north.');
    this.getMap().getView().setRotation(0);
  }

  handleAddRock () {
    editProjectToggleButton(0);
  }

  handleAddRockHere () {
    editProjectToggleButton(1);
  }

  handleDeleteRock () {
    editProjectToggleButton(2);
  }

  handleAddGeotag () {
    editProjectToggleButton(3);
  }

  handleAddGeotagArea () {
    editProjectToggleButton(4);
  }

  toggleLayerList () {
    LayerInfo.refreshAll(ui_layer_infos);
    toggle_control(global_LayerList);
  }

  handleCraneSetMark() {
    global_crane_is_mark_mode = !global_crane_is_mark_mode;
    ui_crane_mark_place_button.innerText = global_crane_is_mark_mode ? "M" : "m";
  }

  handleCranePlaceBlock() {
    if (!global_crane_mark_location) {
      alert('No mark placed!');
      return;
    }
    let crane_heading = 0;
    let begin_location = global_LastCraneBeginPosition?.Location;
    if (!begin_location) {
      begin_location= global_LastCraneVesselPosition?.Location;
    }
    if (begin_location) {
      crane_heading = angle_deg_of_lonlat(begin_location, global_crane_mark_location);
      console.log(`Crane heading to the mark: ${crane_heading} deg`);
    }
    const geotag = {
      Location: global_crane_mark_location,
      Heading: crane_heading,
      BlockWidth: ST.parseFloatWithComma(ui_crane_geotag_width.value),
      BlockLength: ST.parseFloatWithComma(ui_crane_geotag_length.value),
      BlockHeight: ST.parseFloatWithComma(ui_crane_geotag_height.value),
    };
    if (!geotag.BlockWidth || !geotag.BlockLength || !geotag.BlockHeight) {
      alert('Enter geotag block parameters!');
      return;
    }
    clear_crane_mark();
    global_crane_is_mark_mode = true;
    ui_crane_mark_place_button.innerText = "M";
    sendToServer({
      PostMessage: {
        Target: subscription_place_mark,
        Data: { UnMark: true }
      }
    });
    geotag.Description = `Size ${geotag.BlockWidth} x ${geotag.BlockLength} x ${geotag.BlockHeight}`;
    sendToServer({ AddGeotagBlock: geotag });
  }
}

// Prepare style list
let dxfStyles = null;
{
    const style = {
        'Polygon': new Style({
            fill: new Fill({color: 'rgba(0, 0, 255, 0.1)' })
        }),
        'LineString': new Style({
		stroke: new Stroke({color: 'rgba(0, 0, 0, 0.8)', width:2})
        }),
        'Point': new Style({
            image: new CircleStyle ({
                fill: new Fill({color: 'green'}),
                radius: 4
            })
        })
    };
    style['MultiPolygon'] = style['Polygon'];
    style['MultiLineString'] = style['LineString'];
    style['MultiPoint'] = style['Point'];
    style['default'] = style['LineString'];

    dxfStyles = style;
}

const global_SeamarkStyles = {
  'Point': new Style({
  }),
  'LineString': new Style({
    stroke: new Stroke({
      color: 'black',
      width: 2
    })
  }),
  'MultiLineString': new Style({
    stroke: new Stroke({
      color: 'black',
      width: 1
    })
  }),
  'MultiPoint': new Style({
  }),
  'MultiPolygon': new Style({
    stroke: new Stroke({
      color: 'black',
      width: 1
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 0, 0.1)'
    })
  }),
  'Polygon': new Style({
    stroke: new Stroke({
      color: 'black',
      lineDash: [4],
      width: 3
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)'
    })
  }),
  'GeometryCollection': new Style({
    stroke: new Stroke({
      color: 'black',
      width: 2
    }),
    fill: new Fill({
      color: 'magenta'
    }),
    image: new CircleStyle({
      radius: 10,
      fill: null,
      stroke: new Stroke({
        color: 'black'
      })
    })
  }),
  'Circle': new Style({
    stroke: new Stroke({
      color: 'red',
      width: 2
    }),
    fill: new Fill({
      color: 'black'
    })
  })
};

// Base layer.
satelliteLayer = new TileLayer({
  preload: Infinity,
  source: new BingMaps({  // Bing Maps, because the google maps will cause the iPhone to lose GPS :-(
    key: 'Al3QV5F5w9w5QAFapZS0GIRCtoY4BCZ0EKRI-WCPcvVMPXnM2Obpw1Hz96SAIzet',
    imagerySet: 'Aerial',
    // use maxZoom 19 to see stretched tiles instead of the BingMaps
    // "no photos at this zoom level" tiles
    maxZoom: 19
  })
});

// XSEA maps (Navionics)
seamapLayer = new TileLayer({
  visible: false,
  preload: Infinity,
  source: new XYZ({
    attributions: 'Aluskaart: <a href="https://www.navionics.com/fin/legal/acknowledgements" target="_blank">Navionics S.r.l.</a>',
    // {a-z} not needed.
    // maxZoom: global_MapMaxZoom - 1, // most of the maps are generated up to 18, but not all!
    url: global_MapServerUrl + 'MAP/XSEA/{z}/{x}/{y}.png?apikey=username&v=' + global_DatasetVersion,
    minZoom: 2,
    maxZoom: 24,
    tileLoadFunction: loadPngTileSkipOthers
  })
});


// Estonian aerophoto layer.
aerophotoEstoniaLayer = new TileLayer({
  visible: true,
  preload: Infinity,
  // Extent is from https://kaart.maaamet.ee/wms/fotokaart?service=WMS&version=1.3.0&request=GetCapabilities
  extent: olExtent.boundingExtent([[2267911.99, 7708338.90], [3276555.63, 8497206.65]]),
  source: new XYZ({
    attributions: 'Aluskaart: Maa-amet.',
    minZoom: 6, // no tiles on Zooms 0 ... 5.
    // {a-z} not needed.
    // url: 'http://tiles.maaamet.ee/tm/s/1.0.0/hybriid/{z}/{x}/{-y}.png'
    url: 'https://tiles.maaamet.ee/tm/tms/1.0.0/foto@GMC/{z}/{x}/{-y}.jpg'
  })
});

// DTM color-coded depth maps.
const dtmLayer = new TileLayer({
      visible: true,
      preload: Infinity,
      source: new XYZ({
        // {a-z} not needed.
        // url: 'http://Andubox/MAP/DTM/{z}/{x}/{y}.png?apikey=username'
        maxZoom: 20, // most of the maps are generated up to 18, but not all!
        url: global_MapDirectory + '/DTM/{z}/{x}/{y}.png?apikey=username&v=' + global_DatasetVersion
      })
  });

const tifLayer = new TileLayer({
      visible: true,
      preload: Infinity,
      source: new XYZ({
        // {a-z} not needed.
        // url: 'http://Andubox/MAP/TIF/{z}/{x}/{y}.png?apikey=username'
        maxZoom: 22, // most of the maps are generated up to 18, but not all!
        url: global_MapDirectory + '/TIF/{z}/{x}/{y}.png?apikey=username&v=' + global_DatasetVersion
      })
  });

function toColor(bin) {
	const h = bin.toString(16).toUpperCase();
	const r = new Array(7-h.length).join("0") + h;
	return "#" + r;
}

const dxfTextFill = new Fill({color: "black"});
const dxfTextStroke = new Stroke({color: "black", width: 1});

function createDxfLineStyle(feature, resolution) {
	const width = feature.get("strokeWidth");
	const color = feature.get("stroke");
	const r = new Style({
		stroke: new Stroke({
			color: (color==null ? 'black' : toColor(color)),
			width: (width==null ? 1.0 : width)
		})
	});
	return r;
}

function createDxfTextStyle(feature, resolution) {
	const text_text = feature.get("text");
	const height = feature.get("height");
	const rotation = feature.get("rotation");
	
	const r = new Style({
		text: new Text({
			textBaseline: "bottom",
			textAlign: "left",
			font: `normal ${height}px/1 Arial`,
			text: text_text,
			stroke: dxfTextStroke,
			fill: dxfTextFill,
			rotation: rotation,
			rotateWithView: true,
		})
	});
	return r;
}

function loadVectorTileSkipHtml(tile, url) {
  tile.setLoader(async function(extent, resolution, projection) {
    try {
      const response = await fetch(url);
      const contentType = response.headers.get('content-type'); // Synology omits the field "content-type" on *.pbf files when using Apache.
      if (contentType && contentType.startsWith("text/html")) {
        // This is no tile :-(
        // Note: The uint32 array [1329865020, 1348031555, 1952981061, 222194797] correspond to a HTML error message in the development web server.
        tile.setState(TileState.ERROR);
      }
      else {
        const data = await response.arrayBuffer();
        const format = tile.getFormat() // ol/format/MVT configured as source format
        const features = format.readFeatures(data, {
          extent: extent,
          featureProjection: projection
        });
        tile.setFeatures(features);
      }
    } catch (error) {
      consolelog(`Error when loading tile ${url} because: ${error}`);
      tile.setState(TileState.ERROR);
    }
  });
}

/// Load data for the tile only when it is PNG.
async function loadPngTileSkipOthers(tile, url) {
  try {
    const response = await fetch(url);
    const contentType = response.headers.get('content-type');
    if (contentType != "image/png") {
      // This is no raster tile :-(
      // Note: The uint32 array [1329865020, 1348031555, 1952981061, 222194797] correspond to a HTML error message in the development web server.
      tile.setState(TileState.ERROR);
    }
    else {
      const data = await response.blob();
      tile.getImage().src = URL.createObjectURL(data);
    }
  } catch (error) {
    consolelog(`Error when loading tile ${url} because: ${error}`);
    tile.setState(TileState.ERROR);
  }
}

// DXF and DWG files.
const dxfLayer = new VectorTileLayer ({
    //preload: Infinity,
    source: new VectorTileSource ({
        format: new MVT(),
        tileGrid: new createXYZ({
            minZoom: global_MapMinZoom,
            maxZoom: global_MapMaxZoom,
            tileSize: 512,
        }),
        tilePixelRatio: 8,
        url: global_MapDirectory + '/DXF/{z}/{x}/{y}.pbf?apikey=username&v=' + global_DatasetVersion,
        tileLoadFunction: loadVectorTileSkipHtml,
    }),
    // extent: mapExtent,
    style: function(feature, resolution) {
        var layerId = feature.get('layer');
        const type = feature.getType();
        if (type=='LineString' || type=='MultiLineString') {
          return createDxfLineStyle(feature, resolution);
        }
        if (type=='Point' || type=='MultiPoint') {
          return createDxfTextStyle(feature, resolution);
        }
        let style = dxfStyles[type];
        if (!style) {
          style = new Style({
            image: new CircleStyle({fill: new Fill({color: 'red'}), radius: 2.1}),
            stroke: new Stroke({color: 'yellow', width: 1})
          });
        }
        return style;
      }
    });

// Depth text style stuff.
const depth_fontsize = 20;
const depth_font = `normal ${depth_fontsize}px/1 Arial`;
const depth_fontsize_small = 16;
const depth_font_small = `normal ${depth_fontsize_small}px/1 Arial`;
const depth_stroke = new Stroke({color: 'black', width: 1});
const depth_fill = new Fill({color: 'black'});

const createDepthTextStyle = function(feature, resolution) {
    let s_depth = feature.get('depth');
    // In some old tiles, we get undefined depth.
    if (!s_depth || (typeof s_depth == 'number' && s_depth>0)) {
      return null;
    }
    let s = ST.depthTextOf(s_depth, 1);
    // Just in case ST.depthTextOf fails.
    if (!s) {
      consolelog(`createDepthTextStyle: ${s_depth}`);
      return null;
    }
    let s_big = s;
    let text_small = null;
    const pos = s.indexOf('.');
    if (pos >= 0) {
        s_big = s.substring(0, pos);
        text_small = new Text({
            textBaseline: 'top',
            textAlign: 'left',
            font: depth_font_small,
            text: s.substring(pos+1),
            stroke: depth_stroke,
            fill: depth_fill,
            offsetX: 0.40 * depth_fontsize,
            offsetY: 0
        });
    }
    const text_big= new Text({
        textBaseline: 'middle',
        textAlign: 'right',
        font: depth_font,
        text: s_big,
        stroke: depth_stroke,
        fill: depth_fill,
        offsetX: +0.25 * depth_fontsize,
        offsetY: +0.1 * depth_fontsize
    });
    // All features are Points.
    let r = null;
    if (text_small == null) {
        r = new Style({
            // image: overlayDot,
            text: text_big,
        });
    }
    else {
        r = [new Style({
              // image: overlayDot,
              text: text_big
            }),
             new Style({
              text: text_small
        })];
    }
    return r;
};

const SURVEYTYPE_LAND = "Land";
const SURVEYTYPE_SEA = "Sea";

const createLandHeightTextStyle = function(feature, resolution) {
  let s_depth = feature.get('depth');
  // In some old tiles, we get undefined depth.
  if (!s_depth) {
    return null;
  }
  let s = ST.depthTextOf(-s_depth, 2);
  // Just in case ST.depthTextOf fails.
  if (!s) {
    consolelog(`createLandHeightTextStyle: ${s_depth}`);
    return null;
  }
  const text = new Text({
      textBaseline: 'top',
      textAlign: 'left',
      font: depth_font_small,
      text: s,
      stroke: depth_stroke,
      fill: depth_fill,
      offsetX: -1.0 * depth_fontsize,
      offsetY: 0
  });
  // All features are Points.
  var r = new Style({
    // image: overlayDot,
    text: text,
  });
  return r;
};

global_DepthPointsSource = new VectorTileSource ({
  attributions: `<div>Id:${global_UserId}. Merem&otilde;&otilde;dukeskus O&Uuml; 2025.02.12b</div>` +
                `<div style="display:inline-flex"><input id="share-mypos-checkbox" type="checkbox" ${global_IsSharing ? "checked" : ""}>Share me:</input><input id="my-name-text" type="text" size="15" value="${global_UserName}"></input><button id="my-clear-track-button" type="button"><div>Clear<div><br><div>tracks</div></button><button id="export-navimarks-button">NM</button></div>` +
                // '<div>&nbsp;</div>' +
                `<br>` +
                `<div style="display:inline-flex"><input id="use-compass-checkbox" type="checkbox" ${global_IsCompassEnabled ? "checked" : ""}>Compass</input>` +
                `<input id="compasspatch-reverse-checkbox" type="checkbox" ${global_CompassPatchReverse ? "checked" : ""}>Reverse</input>` +
                `<input id="compasspatch-offset" type="text" size="4" value="${global_CompassPatchOffsetDeg.toFixed(1)}"></input>` +
                `<button id="info-devtable-clear-button">ClearDT</button></div>` +
                '<div>&nbsp;</div>'
                ,
  format: new MVT(),
  tileGrid: new createXYZ({
      minZoom: global_MapMinZoom,
      maxZoom: 19, // This has to match the MAX_DEPTH_ZOOM in the MapProject.cs.
      tileSize: 512,
  }),
  tilePixelRatio: 8,
  url: global_MapDirectory + '/DTM/{z}/{x}/{y}.pbf?apikey=username&v=' + global_DatasetVersion,
  tileLoadFunction: loadVectorTileSkipHtml,
});

// Layer of depth points.
const dtmxLayer = new VectorTileLayer ({
    //preload: Infinity,
    source: global_DepthPointsSource,
    // extent: mapExtent,
    style: createDepthTextStyle,
});
if (global_IsDtmxDisabled) {
  dtmxLayer.setVisible(false);
}

function taskAll_CreatePointStyle() {
  if (resolution > 10) {
    return undefined;
  }
  const text_text = feature.get('filename');
  const height = 20.0; // 15.0 / (10 * resolution);
  const rotation = 0;
  const r = new Style({
    text: new Text({
      textBaseline: "bottom",
      textAlign: "middle",
      font: `normal ${height}px/1 Arial`,
      text: text_text,
      stroke: new Stroke({color: "black", width: 1}),
      fill: new Fill({color: "orange"}),
      rotation: rotation,
      rotateWithView: true,
    })
  });
  return r;
}

// Overlays, if any.
const overlayLayer = new VectorLayer({
    source: global_VectorOverlaySource,
    style: function(feature, resolution) {
      const is_following_some_vessel = global_MyposTrackEnable && global_VesselNameToTrack;
      if (feature == global_MyposArrow2Feature) {
        if (is_following_some_vessel) {
          return [];
        }
        return global_MyposStyle2;
      }
      if (feature == global_MyposCenterFeature || feature == global_MyposArrowFeature) {
        if (is_following_some_vessel) {
          return [];
        }
        return global_MyposStyle;
      }
      if (feature == global_MyCourseArrowFeature) {
        if (is_following_some_vessel) {
          return [];
        }
        return global_MyCourseStyle;
      }
      if (feature == global_MyCompassArrowFeature) {
        if (is_following_some_vessel) {
          return [];
        }
        return global_MyCompassStyle;
      }

      const type = feature.getGeometry().getType();
      const style = feature.get('style');
      if (style) {
        return style;
      }

      // FIXME: this can be optimized.
      if (type == 'Point') {
        if (resolution > 10) {
          return undefined;
        }
        const text_text = feature.get('filename');
        const height = 20.0; // 15.0 / (10 * resolution);
        const rotation = 0;
        let fill_color = feature.get('fillColor');
        const r = new Style({
          text: new Text({
            textBaseline: "bottom",
            textAlign: "middle",
            font: `normal ${height}px/1 Arial`,
            text: text_text,
            stroke: new Stroke({color: "black", width: 1}),
            fill: new Fill({color: (fill_color ? fill_color : "orange")}),
            rotation: rotation,
            rotateWithView: true,
          })
        });
        return r;
      }
      return undefined;
    }
});

const vesselsLayer = new VectorLayer({
  source: global_VesselsSource,
  style: function(feature) {
    const style = feature.get('style');
    if (style) {
      return style;
    }

    // Webuser special.
    const vessel_type = feature.get('vesselType');
    if (vessel_type && vessel_type == 'webuser') {
      return global_WebuserStyle;
    }
    
    // Ordinary vessel stuff.
    const gt = feature.getGeometry().getType();
    const tr = feature.get('track');
    const vn = feature.vesselName;
    if (vn == global_VesselNameToTrack) {
      return FS.VectorOverlayStylesFollowedVessel[gt];
    }
    return FS.VectorOverlayStyles[gt];
  }
});

const vesselsTracksLayer = new VectorLayer({
  source: global_VesselsTracksSource,
  style: function(feature) {
    const style = feature.get('style');
    if (style) {
      return style;
    }
    const gt = feature.getGeometry().getType();
    const vn = feature.get('vesselName');
    if ((global_VesselNameToTrack && global_VesselNameToTrack == vn) || (global_SelectedVesselName && global_SelectedVesselName==vn)) {
      return FS.VectorOverlayStylesFollowedTrack[gt];
    }
    return FS.VectorOverlayStylesNone;
  }
});

const seamarksLayer = new VectorLayer({
  source: global_SeamarksSource,
  style: function(feature) {
    return global_SeamarkStyles[feature.getGeometry().getType()];
  }
});


// Do not define Point, as this is special.
const global_RockStyles = {
  'Polygon': new Style({
    stroke: new Stroke({
      color: 'black',
      width: 1
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 0, 0.6)'
    })
  })
};

function createRocksDepthTextStyle(feature, resolution) {
  const x_depth = feature.get('depth');
  const s = ST.depthTextOf(x_depth, 2);
  const fontsize = depth_fontsize / (10 * resolution);
  const text= new Text({
      textBaseline: 'middle',
      textAlign: 'left',
      font: `normal ${fontsize}px/1 Arial`,
      text: '(' + s + ')',
      stroke: depth_stroke,
      fill: depth_fill,
      offsetX: 0 * fontsize,
      offsetY: 0.5 * fontsize
  });
  // All features are Points.
  const r = new Style({
      text: text,
  });
  return r;
}

const rocksLayer = new VectorLayer({
  source: global_RocksSource,
  style: function(feature, resolution) {
    const type = feature.getGeometry().getType();
    var style = global_RockStyles[type];
    if (style) {
      return style;
    }
    return createRocksDepthTextStyle(feature, resolution);
  }
});

const geotagPindropStyle = 
  new Style({
    image: new Icon({
      anchor: [0.5, 1.0],
      crossOrigin: 'anonymous',
      src: MAPDIR_PREFIX + '/pindrop.png',
    }),
  });

const geotagCategoryStyles = {};

for (let category in geotag_categories) {
  const color = geotag_categories[category];
  const new_style = new Style({
    image: new Icon({
      anchor: [0.5, 1.0],
      crossOrigin: 'anonymous',
      src: `${MAPDIR_PREFIX}/pindrop-${color}.png`,
    }),
  });
  geotagCategoryStyles[category] = new_style;
}

const geotagPindropSelectedStyle = 
new Style({
  image: new Icon({
    anchor: [0.5, 1.0],
    crossOrigin: 'anonymous',
    src: MAPDIR_PREFIX + '/pindrop-selected.png',
  }),
});

const geotagsLayer = new VectorLayer({
  source: global_GeotagsSource,
  style: function(feature, resolution) {
    const id = feature.getId();
    if ((global_SelectedGeotagName && global_SelectedGeotagName==id) || (global_GeotagNameToChange === id)) {
      return geotagPindropSelectedStyle;
    }
    const geotag = global_Geotags[id];
    const r = geotagCategoryStyles[geotag.Category];
    return r;
  }
});

// Cosmetics.
document.title = global_ProjectName;

function createGlobalInfoElement(elementName) {
  const e = document.createElement(elementName);
  global_Info.appendChild(e);
  return e;
}

function createElementInParent(parent, elementName) {
  const e = document.createElement(elementName);
  parent.appendChild(e);
  return e;
}

function createGeotagCopyButton(label, tooltip, textToCopy) {
  const button = createGlobalInfoElement('button');
  button.innerText = label;
  button.title = tooltip;
  button.onclick = function() {
    navigator.clipboard.writeText(textToCopy);
  }
  return button;
}

function createInputInParent(parent, id, width, opt_value)
{
  const e = document.createElement('input');
  e.setAttribute('type', 'text');
  e.setAttribute('id', id);
  if (width) {
    e.style.width = width;
  }
  if (opt_value) {
    e.value = opt_value;
  }
  parent.appendChild(e);
  return e;
}

// Add features to the source. Return the features if any.
function addFeaturesToSource(source, features, location, processFeature) {
  const loc_webmercator = fromLonLat(location);
  const loc_x = loc_webmercator[0];
  const loc_y = loc_webmercator[1];
  const scale = LonLatToScale(location);
  for (let i=0; i<features.length; ++i) {
    const feature = features[i];
    const ng = feature.getGeometry();
    scaleGeometry(ng, scale);
    ng.translate(loc_x, loc_y);
    if (processFeature) {
      processFeature(feature);
    }
  }
  source.addFeatures(features);
  return features;
}

function processPlaceMarkMessage(markMessageData)
{
  // drop everything.
  clear_crane_mark();

  const unmark = markMessageData.UnMark;
  if (unmark) {
    console.log('Unmarked the location.');
  }

  const mark_location = markMessageData.MarkLocation;
  if (mark_location) {
    console.log(`place at ${mark_location}`);
    const LENGTH = 5;
    const HEIGHT = 0.2;
    const features = (new GeoJSON()).readFeatures({
      "type": "FeatureCollection",
      "name": "entities",
      "features": [
        {
          "type": "Feature",
          "properties": {},
          "geometry": {
            "type": "LineString",
            "coordinates": [
              [ HEIGHT, -LENGTH ],
              [ -HEIGHT, LENGTH ],
              [ HEIGHT, LENGTH ],
              [ -HEIGHT, -LENGTH ],
              [ HEIGHT, -LENGTH ]
            ]
          }
        },
        {
          "type": "Feature",
          "properties": {},
          "geometry": {
            "type": "LineString",
            "coordinates": [
              [ -LENGTH, HEIGHT ],
              [ LENGTH, -HEIGHT ],
              [ LENGTH, HEIGHT ],
              [ -LENGTH, -HEIGHT ],
              [ -LENGTH, HEIGHT ]
            ]
          }
        }
      ]
    });
    ui_crane_mark_features = addFeaturesToSource(global_VectorOverlaySource, features, mark_location, (f) => f.set('style', FS.CraneMarkStyle));
    global_crane_mark_location = mark_location;
  }
}

function createGlobalYoutubeLine()
{
  const input_id = 'youtubeinput';
  let div = createGlobalInfoElement('div');
  div.style.display = 'flex';

  const clear_button = createElementInParent(div, 'button');
  clear_button.innerText = 'Clear YT';
  clear_button.title = 'Clear the input box';

  const add_yt_button = createElementInParent(div, 'button');
  add_yt_button.innerText = 'Add YT';
  add_yt_button.title = 'Add YouTube video to this Tag';

  const input_label = createElementInParent(div, 'label');
  input_label.for = input_id;

  const youtube_input = createInputInParent(div, input_id, '100%');

  clear_button.onclick = function() {
    youtube_input.value = "";
  };
  return [add_yt_button, youtube_input];
}

function disableGlobalInfo() {
  disable_control(global_Info);
  disable_control(global_GeotagCategoryList);
}

function sendGeotagChangeToServer(geotag_name, geotag_changes) {
  sendToServer({
    ChangeGeotag: {
      Key: geotag_name,
      Value: geotag_changes 
    }
  });
  global_Info.innerText = '';
  disableGlobalInfo();
}


// Show information about Geotag.
function showGeotagInfo(geotagName) {
  const YOUTUBE_PREFIX = 'https://youtu.be/';
  const YOUTUBE_DEFAULT_WIDTH = 560;
  const YOUTUBE_DEFAULT_HEIGHT = 315;

  clear_control(global_Info);

  const geotag = global_Geotags[geotagName];
  const old_selected_name = global_SelectedGeotagName;
  global_SelectedGeotagName = geotagName;
  if (old_selected_name) {
    const old_feature = global_GeotagsSource.getFeatureById(old_selected_name);
    old_feature.changed();
  }
  const new_feature = global_GeotagsSource.getFeatureById(geotagName);
  new_feature.changed();
  const CRLF = '\r\n';

  let geotag_url = null;
  if (global_IsPrivate) {
    const pn = window.location.pathname;
    const pd = pn.substring(0, pn.lastIndexOf('/'));
    geotag_url = ST.joinUrl(window.location.origin, pd, global_dir, "index.html", `?geotag=${geotagName}`);
  }
  else {
    geotag_url = `${window.location.origin}${window.location.pathname}?dir=${global_dir}&geotag=${geotagName}`;
  }
  const geotag_location_text = ST.toStringHDM(geotag.Location, 5);
  createGeotagCopyButton('Copy link', 'Copy link to clipboard', geotag_url);
  createGeotagCopyButton('Copy lat&lon', 'Copy latitude and longitude to clipboard', geotag_location_text);
  let savetext_button = null;
  let add_youtube_button = null;
  let add_youtube_text = null;
  if (global_IsEditProjectEnabled) {
    // Button: Delete
    createButton(global_Info, 'Delete', 'Delete this geotag', () => sendToServer({ deleteGeotag: geotagName }));

    // Button: Save text
    savetext_button = createGlobalInfoElement('button');
    savetext_button.innerText = 'Save text';
    savetext_button.title = 'Save description text';
    // Button: Upload image
    const upload_image_input = createGlobalInfoElement('input');
    upload_image_input.setAttribute('type', 'file');
    upload_image_input.setAttribute('style', 'display:none');
    upload_image_input.setAttribute('accept', 'image/*');
    upload_image_input.setAttribute('multiple', true);
    upload_image_input.addEventListener('change', function() {
      const files_length = this.files.length;
      if (files_length == 0) {
        return;
      }
      for (let i_files=0; i_files<files_length; ++i_files) {
        const f_i = this.files[i_files];
        const reader = new FileReader();
        reader.onload = function(event) {
          sendToServer({
            UploadImageToGeotag: {
              Key: geotagName,
              Value: {
                Name: f_i.name,
                Data: btoa(event.target.result)
              }
            }
          });
        }
        reader.readAsBinaryString(f_i);
      }
    }, false);

    createButton(global_Info, 'Upload image', 'Upload image from a file', () => upload_image_input.click());
    createButton(global_Info, 'Category:', 'Select new category', () => {
      if (is_control_enabled(global_GeotagCategoryList)) {
        disable_control(global_GeotagCategoryList);
      }
      else {
        const new_bottom = global_Info.clientHeight + 25;
        global_GeotagCategoryList.style.bottom = `${new_bottom}px`; //`${new_bottom}px`;
        enable_control(global_GeotagCategoryList);
      }
    });
    const text_span = createGlobalInfoElement('span');
    const geotag_category = geotag.Category;
    if (geotag_category) {
      text_span.innerText = geotag_category;
    }
    GeotagCategoryInfo.refreshAll(ui_geotag_category_infos, geotag_category, (new_category) => {
      console.log(`${geotagName} => ${new_category}`);
      sendGeotagChangeToServer(geotagName, { Category: new_category });
      disable_control(global_GeotagCategoryList);
    });

    createGlobalInfoElement('br');
    [add_youtube_button, add_youtube_text] = createGlobalYoutubeLine();
  }
  createGlobalInfoElement('br');

  const date = new Date(geotag.TimestampUtc * 1000);
  const text_span = createGlobalInfoElement('span');
  if (global_IsEditProjectEnabled) {
    const lat_id = 'geotag_latitude_edit';
    const lon_id = 'geotag_longitude_edit';
    text_span.innerText = date.toString() + CRLF + 'Pos: ';
    const lat_input = createInputInParent(global_Info, lat_id, '100px', ST.latitudeToHDM(geotag.Location[1], 5));
    const lon_input = createInputInParent(global_Info, lon_id, '100px', ST.longitudeToHDM(geotag.Location[0], 5));
    createButton(global_Info, 'Save new loc.', 'Save the new location', () => {
      try {
        const new_lat = ST.parseHDM(lat_input.value);
        const new_lon = ST.parseHDM(lon_input.value);
        if (new_lon && new_lat) {
          sendGeotagChangeToServer(geotagName, {Location:[new_lon, new_lat]} );
        }
      }
      catch (ex) {
        alert(ex);
      }
    });

    createButton(global_Info, 'Pick location', 'Pick a new location on the map', () => {
      clear_control(global_Info);
      createButton(global_Info, 'Cancel pick', 'Cancel picking a new location on the map', () => {
        global_GeotagNameToChange = null;
        showGeotagInfo(geotagName);
      });
      const description_span = createGlobalInfoElement('span');
      description_span.innerText = geotag.Description;
      global_GeotagNameToChange = geotagName;
    });
  }
  else {
    text_span.innerText = date.toString() + CRLF + 'Pos: ' + geotag_location_text;
  }

  createGlobalInfoElement('br');
  if (global_IsEditProjectEnabled) {
    const input_text = createGlobalInfoElement('textarea');
    input_text.value = geotag.Description;
    input_text.style.width = '95%';
    savetext_button.onclick = () => sendGeotagChangeToServer(geotagName, { Description: input_text.value });
    add_youtube_button.onclick = function() {
      let text = add_youtube_text.value;
      let youtube_link = null;
      if (text.startsWith(YOUTUBE_PREFIX)) {
        youtube_link = text;
      }
      else {
        const v_index = text.indexOf('v=');
        if (v_index>=0) {
          const videotag = text.substring(v_index + 2);
          youtube_link = YOUTUBE_PREFIX + videotag;
        }
      }
      if (youtube_link == null) {
        throw 'Not a youtube link!';
      }
      const videolinks = geotag.VideoLinks!=null && geotag.VideoLinks.length>0 ? geotag.VideoLinks : [];
      videolinks.push(youtube_link);
      sendToServer({
        ChangeGeotag: {
          Key: geotagName,
          Value: { VideoLinks: videolinks }
        }
      });
      global_Info.innerText = '';
      disableGlobalInfo();
    };
  }
  else {
    const category_span = createGlobalInfoElement('span');
    category_span.innerText = geotag.Category;
    category_span.style.background = geotag_categories[geotag.Category];
    createGlobalInfoElement('span').innerText = ': ';

    const description_span = createGlobalInfoElement('span');
    description_span.innerText = geotag.Description;
  }
  createGlobalInfoElement('br');

  let nrows = 0;
  if (geotag.Files && geotag.Files.length>0) {
    ++nrows;
  }
  if (geotag.VideoLinks && geotag.VideoLinks.length>0) {
    ++nrows;
  }

  const img_height = Math.round(global_Map.getSize()[1] / (3 + nrows)).toString();
  if (geotag.Files && geotag.Files.length>0) {
    geotag.Files.forEach(filename => {
      const a = createGlobalInfoElement('a');
      const img_url = `./${global_dir}/Geotag/${geotagName}/${filename}`;
      a.target = "_blank";
      window.setTimeout(() => a.href = img_url, 1000); // Delay avoids clicking direct on the image URL.
      const img = document.createElement('img');
      img.src = img_url;
      img.height = img_height;
      a.appendChild(img);
    });
  }

  if (geotag.VideoLinks != null && geotag.VideoLinks.length>0) {
    createGlobalInfoElement('br');
    geotag.VideoLinks.forEach(link => {
      const last_slash_pos = link.lastIndexOf('/');
      if (last_slash_pos < 0) {
        return;
      }
      const map_size = global_Map.getSize();
      const max_w = Math.round(0.7 * map_size[0]);
      const max_h = Math.round(0.8/nrows * map_size[1]);
      let video_h = YOUTUBE_DEFAULT_HEIGHT;
      let video_w = YOUTUBE_DEFAULT_WIDTH;
      if (video_h>max_h) {
        video_h = max_h;
        video_w = Math.round(video_h * YOUTUBE_DEFAULT_WIDTH / YOUTUBE_DEFAULT_HEIGHT);
      }
      if (video_w>max_w) {
        video_w = max_w;
        video_h = Math.round(video_w * YOUTUBE_DEFAULT_HEIGHT / YOUTUBE_DEFAULT_WIDTH);
      }
      const videotag = link.substring(last_slash_pos + 1);
      /* the embedded HTML code as provided by Youtube doesn't work. Thus the use of Javascript API. */
      const videodiv = createGlobalInfoElement('div');
      const player = new YT.Player(videodiv, {
        height: video_h,
        width: video_w,
        videoId: videotag,
        events: {
          'onReady': (event) => event.target.playVideo(),
        }
      });
    });
  }
  enable_control_with_opacity(global_Info, 1);
  return;
}

function showNavigationInfo(navigationInfo) {
  const CRLF = '\r\n';
  const text_span = createGlobalInfoElement('span');
  text_span.innerText =
    navigationInfo.estno + CRLF
    + navigationInfo.color + ' ' + navigationInfo.colors + CRLF
    + navigationInfo.name + CRLF
    + 'Staatus:' + (navigationInfo.status==0 ? 'Korras' : `Rike: ${navigationInfo.status}`) + CRLF
    + ST.toStringHDM(navigationInfo.position, 5) + CRLF;
  createGlobalInfoElement('br');
  enable_control_with_opacity(global_Info, 1);
}

function showVesselInfo(vesselName) {
  const vessel = global_Vessels[vesselName];
  if (!vessel || vessel.InfoDisabled) {
    return;
  }
  global_SelectedVesselName = vesselName;
  if (!global_SelectedVesselText) {
    global_SelectedVesselText = createGlobalInfoElement('span');
    createGlobalInfoElement('br');
  }
  const vessel_status = vessel.Status;
  let vessel_status_time = null;
  if (vessel.StatusTime) {
    var now = new Date();
    const diff_sec = Math.floor(now - vessel.StatusTime) * 0.001;
    vessel_status_time = ST.hoursMinutesTextOfSeconds(diff_sec);
  }
  const lines = [ `${vesselName} ${vessel_status==null ? '' : vessel_status} ${vessel_status_time==null ? '' : vessel_status_time}` ];
  if ('Pk' in vessel) {
    lines.push(`${vessel.Pk.toFixed(1)} Pk`)
  }
  const loc = vessel.Position;
  if (loc) {
    lines.push(ST.toStringHDM(loc, 5));
  }

  let vessel_speed = null;
  let vessel_speed_knots = null;
  if ('SpeedKnots' in vessel) {
    vessel_speed_knots = vessel.SpeedKnots;
    vessel_speed = 'Spd: ' + vessel_speed_knots.toFixed(1);
  }
  let vessel_course = null;
  let vessel_course_deg = null;
  if ('TrackDeg' in vessel) {
    vessel_course_deg = vessel.TrackDeg;
    vessel_course = 'Cog: ' + vessel_course_deg.toFixed(1);
  }

  let heading_lines = [];
  let first_heading = null;
  let first_heading_deg = null;
  for (let partName in vessel.Parts) {
    const part = vessel.Parts[partName];
    let sline = "";
    if (part.InfoDisabled) {
      continue;
    }
    if ('Heading' in part) {
      const heading = part.Heading;
      sline = `${sline} Hdg:${heading.toFixed(1)}`;
      if (!first_heading) {
        first_heading_deg = heading;
        first_heading = 'Hdg: ' + heading.toFixed(1);
      }
    }
    if ('Tilt' in part) {
      sline = `${sline} Tilt:${part.Tilt.toFixed(1)}`;
    }
    if ('Altitude' in part) {
      sline = `${sline} Alt:${part.Altitude.toFixed(1)}`;
    }
    if (sline.length > 0) {
      heading_lines.push(`${partName}:${sline}`);
    }
  }
  let course_and_speed = null;
  if (vessel_speed!=null || vessel_course!=null) {
    course_and_speed = `${vessel_course==null ? '' : vessel_course} ${vessel_speed==null ? '' : vessel_speed}`;
  }
  if (heading_lines.length > 1) {
    lines.push(...heading_lines);
    if (course_and_speed != null) {
      lines.push(course_and_speed);
    }
  }
  else {
    if (first_heading != null || course_and_speed!=null) {
      lines.push(`${first_heading==null ? '' : first_heading} ${course_and_speed==null ? '' : course_and_speed}`);
    }
  }

  global_SelectedVesselText.innerText = lines.join('\r\n');
  enable_control_with_opacity(global_Info, 1);
  const info_timeout_seconds = vessel.InfoTimeoutSeconds;
  if (info_timeout_seconds && info_timeout_seconds>0) {
    setTimeout(() => {
      disable_control(global_Info);
      vessel.InfoDisabled = true;
    }, 1000 * info_timeout_seconds);
  }

  if (global_MyposTrackEnable && global_VesselNameToTrack == vesselName) {
    showNavigationInfoCourseSpeed(first_heading_deg, vessel_course_deg, vessel_speed_knots);
  }
}

function processMouseClick(event) {
  // Clear the show before doing anything.
  clear_control(global_Info);
  disableGlobalInfo();
  const features = global_Map.getFeaturesAtPixel(event.pixel);
  const coordinates = global_Map.getCoordinateFromPixel(event.pixel);
  if (global_GeotagNameToChange) {
    const lonlat = toLonLat(coordinates);
    sendGeotagChangeToServer(global_GeotagNameToChange, {Location:lonlat} );
    global_GeotagNameToChange = null;
    return;
  }

  if (global_SelectedGeotagName) {
    const feature = global_GeotagsSource.getFeatureById(global_SelectedGeotagName);
    global_SelectedGeotagName = null;
    if (feature) {
      feature.changed();
    }
  }

  if (global_SelectedVesselName) {
    global_SelectedVesselName = null;
    global_SelectedVesselText = null;
  }

  // Process the mouse.
  if (global_EditProjectHandler != null) {
    global_EditProjectHandler(event, coordinates, features);
    return;
  }

  if (global_crane_is_mark_mode) {
    const lonlat = toLonLat(coordinates);
    const data = {
      MarkLocation: lonlat
    };
    processPlaceMarkMessage(data);
    const msg = {
      PostMessage: {
        Target: subscription_place_mark,
        Data: data
      }
    };
    sendToServer(msg);
    return;
  }

  // Add new info.
  if (features.length == 0) {
    // Coordinates.
    const lonlat = toLonLat(coordinates);
    const zoom100 = Math.round(100 * global_View.getZoom());
    const z1 = Math.trunc(zoom100 / 100);
    const z2 = zoom100 % 100;
    global_Info.innerText = `${ST.toStringHDM(lonlat, 4)}\r\nZoom: ${z1}.${z2.toString().padStart(2, '0')}\r\n`;
    enable_control_with_opacity(global_Info, 0.5);
    return;
  }
  const f0 = features[0];
  const geotagName = f0.geotagName;
  if (geotagName) {
    showGeotagInfo(geotagName);
    return;
  }
  const ni = f0.navigationInfo;
  if (ni) {
    showNavigationInfo(ni);
    return;
  }

  const vesselName = f0.vesselName;
  if (vesselName) {
    // FIXME: do what?
    const vessel = global_Vessels[vesselName];
    if (vessel) {
      vessel.InfoDisabled = false;
      showVesselInfo(vesselName);
    }
    return;
  }

  const filename = f0.get('filename');
  if (filename) {
    global_Info.innerText = ' ' + filename + ' ';
    enable_control_with_opacity(global_Info, 1);
    return;
  }

  // Track of a vessel.
  const trackVesselName = f0.trackVesselName;
  if (trackVesselName) {
    global_Info.innerText = `Track of ${trackVesselName}`;
    enable_control_with_opacity(global_Info, 1);
    return;
  }

  // Just properties.
  const properties = f0.getProperties();
  global_Info.innerText = JSON.stringify(properties, null, 2);
  enable_control_with_opacity(global_Info, 1);
}

global_View = new View({
	center: global_DefaultPosition,
	zoom: 17,
	minZoom: global_MapMinZoom,
    });

let global_ScaleLine = null;

vesselsTracksLayer.setZIndex(1);
dxfLayer.setZIndex(1);  // does this help against losing layers?
overlayLayer.setZIndex(2);  // does this help against losing layers?
vesselsLayer.setZIndex(5);  // does this help against losing layers?

ui_layer_infos = [
  new LayerInfo(satelliteLayer, 'Satellite photo', 'Satellite view'),
  new LayerInfo(aerophotoEstoniaLayer, 'Aerial photo', 'Aerial photo, only in Estonia'),
  new LayerInfo(seamapLayer, 'Navionics', 'Navionics Sea Charts, not all is covered.', (is_visible) => {
    if (is_visible) {
      enable_control(global_NavionicsLogo);
    }
    else {
      disable_control(global_NavionicsLogo);
    }
  }),
	new LayerInfo(dtmLayer, 'Depth photo', 'Depth as photo'),
	new LayerInfo(dxfLayer, 'Technical drawing', 'Vector technical drawings'),
  new LayerInfo(dtmxLayer, 'Depth reading', 'Depth readings as numbers'),
  new LayerInfo(tifLayer, 'GeoTiff', 'Data in GeoTiff format'),
  new LayerInfo(vesselsTracksLayer, 'Vessel track', 'Vessel tracks'),
  // new LayerInfo(overlayLayer, '', ''),
  new LayerInfo(vesselsLayer, 'Vessel', 'Vessels on the map'),
  new LayerInfo(seamarksLayer, 'Seamark', 'Estonian seamarks'),
  new LayerInfo(rocksLayer, 'Rock', 'Labelled rocks'),
  new LayerInfo(geotagsLayer, 'Geotag', 'Geographical tags')
];

LayerInfo.initAll(ui_layer_infos);

for (let category in geotag_categories) {
  const color = geotag_categories[category];
  const new_info = new GeotagCategoryInfo(category, color);
  ui_geotag_category_infos.push(new_info);
}


global_Map = new Map({
    target: 'map',
    layers: [
      satelliteLayer,
      aerophotoEstoniaLayer,
      seamapLayer,
	    dtmLayer,
	    dxfLayer,
      dtmxLayer,
      tifLayer,
      vesselsTracksLayer,
      overlayLayer,
      vesselsLayer,
      seamarksLayer,
      rocksLayer,
      geotagsLayer
    ],
    view: global_View,
    controls: new Collection(),
});

/* Disabled 24b: running OK
      vesselsTracksLayer,
      overlayLayer,
      vesselsLayer,
      seamarksLayer,
      rocksLayer,
      geotagsLayer
Disabled 24c: running OK
      seamarksLayer,
      rocksLayer,
      geotagsLayer
Disabled 24d: crashing
      rocksLayer,
      geotagsLayer
Disabled 24e: crashing
      seamarksLayer,
Disabled 24f: crashing
      seamarksLayer,
      rocksLayer,
Disabled 24g: crashing
      seamarksLayer,
      geotagsLayer
Disabled 24h: crashing (note 24c)
      seamarksLayer,
      rocksLayer,
      geotagsLayer
Disabled 24i:  works OK
      overlayLayer,
      seamarksLayer,
      rocksLayer,
      geotagsLayer
Disabled 24j: crashing
      overlayLayer,
Disabled 24k: crashing
      overlayLayer,
      seamarksLayer,
Disabled 24l: crashing
      depth texts disabled
      overlayLayer,
      seamarksLayer,
Disabled 24m:
      rotation
      overlayLayer,
      seamarksLayer,
Disabled 24o:
      overlayLayer,
      seamarksLayer,
      geotagsLayer
Disabled 24q:
      Rotation disabled
      overlayLayer,
      seamarksLayer,
      geotagsLayer
Disabled 24r:
      Rotation disabled
      seamarksLayer,
      geotagsLayer
Disabled 24s:
      Rotation disabled
 */

global_Map.addControl(new Zoom());
global_Map.addControl(new Rotate({ className: 'mary-rotate-control' }));
const global_Attributions = new Attribution();
global_Map.addControl(global_Attributions);
global_Map.addControl(global_FullScreen_Normal);
global_Map.addControl(new MaryMapControl());

if (global_IsTileDebug) {
  global_Map.addLayer(new TileLayer({
    source: new TileDebug()
  }));
}

global_Map.on('click', processMouseClick);
// We need px1 and px2 only to disable rotation
let px1 = new PinchRotate();
let px2 = new DragRotate();
let interactions = global_Map.getInteractions();
for (let i=0; i<interactions.getLength(); ++i) {
  const ee = interactions.item(i);
  if (ee.constructor.name == px1.constructor.name) {
    global_Map.removeInteraction(ee);
    continue;
  }
  if (ee.constructor.name == px2.constructor.name) {
    global_Map.removeInteraction(ee);
    continue;
  }
}
// global_Map.removeInteraction(bad_interaction);
global_Map.addInteraction(global_GeotagsDraw);

function is_position_ok(pos) {
  const is_pos_ok = pos && pos.length>1 && Number.isFinite(pos[0]) && Number.isFinite(pos[1]);  // does GPS give us bad data?
  return is_pos_ok;
}

function handle_Mypos(time, pos, p_speed, p_heading_rad) {
  if (!is_position_ok(pos)) {
    return;
  }
  sendToServer({Position : {
    TimestampNetUtc: ST.getTimestampNetUtcFromMs(time),
    Location: toLonLat(pos),
    Heading: global_CompassHeadingDeg,
    Speed: p_speed
  }});
    
  const EFFECTIVE_MIN = 0.5;
  const EFFECTIVE_MAX = 10.0;
  const speed = p_speed===undefined || !Number.isFinite(p_speed) ? 0.0 : p_speed;
  ++global_MyposCount;
  global_MyposSpeedFiltered = 0.75 * global_MyposSpeedFiltered + 0.25 * speed;
  const effective_speed = Math.min(EFFECTIVE_MAX, Math.max(EFFECTIVE_MIN, global_MyposSpeedFiltered));
  const effective_DirectionTimeMilliseconds = Math.sqrt(EFFECTIVE_MAX / effective_speed) * global_DirectionTimeMilliseconds;
  while (global_MyposPosition.length>2 && (time - global_MyposPosition[0][0])>effective_DirectionTimeMilliseconds) {
    // keep at least 2 for the purpose of speed and direction calculation.
    global_MyposPosition.shift();
  }
  let gps_speed = p_speed;
  if (gps_speed===undefined || !Number.isFinite(gps_speed)) {
    if (global_MyposPosition.length>0) {
      const mp = global_MyposPosition[0];
      gps_speed = (1000.0 * distance(mp[1], pos)) / (time - mp[0]);
    }
    else {
      gps_speed = 0.0;
    }
  }
  let gps_heading_rad = p_heading_rad;
  if (gps_heading_rad===undefined || !Number.isFinite(gps_heading_rad)) {
    if (global_MyposPosition.length>0) {
      const p_old = global_MyposPosition[0][1];
      const p_new = pos;
      const dx = p_new[0] - p_old[0];
      const dy = p_new[1] - p_old[1];
      gps_heading_rad = Math.PI/2 - Math.atan2(dy, dx);
      while (gps_heading_rad < 0) {
        gps_heading_rad += 2 * Math.PI;
      }
    }
    else {
      gps_heading_rad = 0;
    }
  }

  global_MyposPosition.push([time, pos, gps_speed * ms2knots, gps_heading_rad * rad2deg, global_CompassHeadingDeg]);
  global_MyTracks.addPoint(pos);
  global_MyposSpeed = speed;
  if (global_IsDeviationTableEnabled) {
    devtable_process(time);
  }
  set_ui_to_mypos();
  //if (!global_FakeMyposEnabled) {
    /*
    console.log('pos[' + global_MyposCount + ']: ' + pos+ ' speed: ' + gps_speed + ' heading: ' + gps_heading_rad * rad2deg);
    */
    /*
    sendToServer({Position : {
      TimestampNetUtc: ST.getTimestampNetUtcFromMs(time),
      Location: toLonLat(pos),
      Heading: gps_heading_rad * rad2deg,
      Speed: gps_speed  * ms2knots
    }});
    */
  //}
}

function fake_Mypos() {
  ++global_FakeMyposCount;
  var time = Date.now();
  const time_pos = global_MyposPosition[global_MyposPosition.length - 1];
  const new_speed = global_FakeMyposSpeed + global_FakeMyposAcceleration;
  if (new_speed >= 2) {
    global_FakeMyposAcceleration = -0.1;
  }
  if (new_speed < 0.1) {
    global_FakeMyposAcceleration = +0.1;
  }
  global_FakeMyposSpeed = new_speed;
  const effective_speed = new_speed * global_FakeMyPosSpeedIncrease;
  const dx = effective_speed * Math.sin(global_FakeMyposDirectionRad);
  const new_x = time_pos[1][0] + dx;
  const dy = effective_speed * Math.cos(global_FakeMyposDirectionRad);
  const new_y = time_pos[1][1] + dy;
  const new_pos = [new_x, new_y];
  handle_Mypos(time, new_pos, effective_speed, global_FakeMyposDirectionRad);
  global_Map.render();
}

function fetch_json(path, handle_json) {
	// There must be a Task_SHOW.geojson.
	const xhr = new XMLHttpRequest();
	xhr.open("GET", path, true);
	// Following line is just to be on the safe side;
	// not needed if your server delivers JSON with correct MIME type
	xhr.overrideMimeType("application/json");
	xhr.onreadystatechange = function() {
		if (this.readyState == 4 && this.status == 200) {
			const json = JSON.parse(this.responseText);
			handle_json(json);
		}
	};
	xhr.send("");
}

function fetch_geojson(path, handle_geojson) {
  fetch_json(path, function (json) {
    const features = (new GeoJSON()).readFeatures(json);
    handle_geojson(features);
  });
}

document.onkeypress = function(evt) {
  const zoom_step = 0.5;
  evt = evt || window.event;
  const charCode = evt.which || evt.keyCode;
  const charStr = String.fromCharCode(charCode);
  if (charStr == "-") {
    global_View.adjustZoom(-zoom_step);
  }
  else if (charStr == "+") {
    global_View.adjustZoom(zoom_step);
  }
  else if (charStr == 'p') {
    if (global_IsDebug && !global_FakeMyposEnabled) {
      consolelog('Fake position: enabled.');
      if (global_MyposPosition.length == 0) {
        global_MyposPosition.push([Date.now(), global_DefaultPosition]);
      }
      global_FakeMyposEnabled = true;
      ++global_FakeMyPosSpeedIncrease;
      global_FakeMyposTimer = window.setInterval(fake_Mypos, 1000);
    }
  }
  else if (charStr == 'r') {
    if (global_IsDebug && global_FakeMyposEnabled) {
      consolelog('Fake position: disabled.');
      global_FakeMyposEnabled = false;
      global_FakeMyPosSpeedIncrease = 0;
      window.clearInterval(global_FakeMyposTimer);
    }
  }
};

global_View.on('change:resolution', (evt) => set_ui_to_mypos());

// Task_SHOW must always be there.
fetch_geojson(`./${global_dir}/Task_SHOW.geojson?v=${global_DatasetVersion}`, (geojson) => {
  global_View.setCenter(ST.centerOfFeatures(geojson));
  // Follow Geotag only after loading Task_SHOW in order to show the correct location when geotag tag is given.
  fetch(`./${global_dir}/Geotag/index.json?v=${global_DatasetVersion}`).
    then(response => response.json()).
    then(geotags => {
      console.log(`Got geotags: ${geotags}`);
      const index = geotags.Index;
      for (let subdir in index) {
        var gt = index[subdir];
        addGeotag(subdir, gt);
        if (global_Geotag && global_Geotag==subdir) {
          showGeotagInfo(subdir);
          global_View.setCenter(fromLonLat(gt.Location));
        }
      }
    });
});

const AllTaskAllFeatures = [];

function countBadCoordinates(vectorSource) {
  let bad_coordinate_count = 0;
  vectorSource.forEachFeature(f => {
    const ng = f.getGeometry();
    const c = ng.getCoordinates();
    if (!c) {
      return false;
    }
    if (c.length==2 && typeof c[0] == 'number') {
      if (!is_position_ok(c)) {
        ++bad_coordinate_count;
      }
    }
    else {
      for (let i=0; i<c.length; ++i) {
        if (!is_position_ok(c[i])) {
          ++bad_coordinate_count;
        }
      }
    }
    return false;
  });
  return bad_coordinate_count;
}

function checkTaskAllFeatures() {
  let found_count = 0;
  const bad_overlays = countBadCoordinates(global_VectorOverlaySource);
  const bad_tracks = countBadCoordinates(global_VesselsTracksSource);
  const bad_vessels = countBadCoordinates(global_VesselsSource);
  global_VectorOverlaySource.forEachFeature(f => {
    if (AllTaskAllFeatures.includes(f)) {
      ++found_count;
    }
    return false;
  });
  if (found_count == AllTaskAllFeatures.length && AllTaskAllFeatures.length>0) {
    consolelog(`Task_ALL.geojson: OK for ${AllTaskAllFeatures.length} features, bad overlays:${bad_overlays} bad tracks:${bad_tracks} bad vessels:${bad_vessels} `);
  }
  else {
    consolelog(`Task_ALL.geojson: BAD, found ${found_count} out of ${AllTaskAllFeatures.length}, bad overlays:${bad_overlays} bad tracks:${bad_tracks} bad vessels:${bad_vessels}`);
  }
  window.setTimeout(checkTaskAllFeatures, 5 * 60 * 1000);
}

fetch_geojson(`./${global_dir}/Task_ALL.geojson?v=${global_DatasetVersion}`, function(features) {
  consolelog(`Task_ALL.geojson: Loaded with ${features.length}`);
  for (let i=0; i<features.length; ++i) {
    const f = features[i];
    const filename = f.get('filename');
    f.set('style', FS.CreateStrokeStyle('red'));
    global_VectorOverlaySource.addFeature(f);
    AllTaskAllFeatures.push(f);

    if (filename) {
      const ext = f.getGeometry().getExtent();
      const center = [(ext[0] + ext[2])/2, (ext[1] + ext[3])/2];
      const f_point = new Feature({
        geometry: new Point(center),
      });
      f_point.set('filename', filename);
      global_VectorOverlaySource.addFeature(f_point);
      AllTaskAllFeatures.push(f_point);
    }
  }
  consolelog(`Task_ALL.geosjon: monitoring ${AllTaskAllFeatures.length} features.`);
  window.setTimeout(checkTaskAllFeatures, 30 * 1000);
});


/// Update the dataset version in the source string.
function newSourceUrl(url) {
  var keypos = url.indexOf('&v=');
  if (keypos < 0) {
    return url;
  }
  return url.substring(0, keypos) + '&v=' + global_DatasetVersion;
}

function reload_layer(layer, name) {
  consolelog('Refreshing layer ' + name);
  const source = layer.getSource();
  const new_urls = source.getUrls().map(newSourceUrl);
  source.setUrls(new_urls);
  source.refresh({force: true});
  source.changed();
  layer.changed();
}

function downloadNavimarksByUser()
{
  const d = new Drawing();
  d.setUnits('Meters');
  d.addLayer('navimark', Drawing.ACI.BLACK, 'CONTINUOUS');
  d.setActiveLayer('navimark');

  const trn = proj4('EPSG:4326', 'EPSG:3301');
  const toLambertEst = trn.forward;

  const seamarkdrawings = global_SeamarkDrawings;
  for (let i=0; i<global_Seamarks.length; ++i) {
    const ni = global_Seamarks[i];
    let f = null;
    if (f==null && ni.typename in seamarkdrawings) {
      f = seamarkdrawings[ni.typename];
    }
    if (f==null && ni.type in seamarkdrawings) {
      f = seamarkdrawings[ni.type];
    }

    const scale = LonLatToScale(ni.position);
    const pos_est = toLambertEst(ni.position);
    // Plot on the DXF.
    f.forEach(item => {
      const ng = item.getGeometry();
      const gc = ng.getCoordinates();
      if (gc && gc.length>0) {
        const nc = gc.map(xy => {
          const nx = pos_est[0] + scale * xy[0];
          const ny = pos_est[1] + scale * xy[1];
          return [nx, ny];
        });
        if (nc.length == 2) {
          const p0 = nc[0];
          const p1 = nc[1];
          d.drawLine(p0[0], p0[1], p1[0], p1[1]);
        }
        else if (nc.length>2) {
          d.drawPolyline(nc);
        }
      }
    });
  }
  const s = d.toDxfString();
  ST.downloadByUser(s, 'navimark.dxf', 'application/dxf');
}

function install_just_once(elementId, installAction) {
  const control = document.getElementById(elementId);
  if (!control.installed) {
    control.installed = true;
    installAction(control);
  }
}

const openlayers_attributions_button = document.querySelector('button[title=\"Attributions\"]');

openlayers_attributions_button.addEventListener('click', evt => {
  // 1. Refresh the tiles when clicking the info button.
  // 2. Support other operations, too.
  const myscale = document.querySelector('.my-map-scale');
  if (evt.currentTarget.parentElement.classList.contains('ol-collapsed')) {
    enable_control_with_opacity(myscale, 1);
  }
  else {
    disable_control(myscale);
    global_DatasetVersion = getNextDatasetVersion();
    reload_layer(dtmxLayer, 'DTMX');
    reload_layer(dxfLayer, 'DXF');
    reload_layer(dtmLayer, 'DTM');
    reload_layer(dtmLayer, 'TIF');
    install_just_once('my-clear-track-button', button => {
      button.addEventListener('click', () => {
        console.log("Clearing all tracks...");
        global_MyTracks.clear();
      });
    });
    install_just_once('export-navimarks-button', button => button.addEventListener('click', downloadNavimarksByUser));
    install_just_once('share-mypos-checkbox', checkbox => {
      checkbox.addEventListener('change', () => {
        global_IsSharing = checkbox.checked;
        localStorage.setItem(ISSHARING_KEYNAME, global_IsSharing);
        global_LoginMessage.IsSharing = global_IsSharing;
        sendToServer({ Login : global_LoginMessage });
      });
    });
    install_just_once('my-name-text', textbox=> {
      textbox.addEventListener('change', () => {
        global_UserName = textbox.value;
        localStorage.setItem(USERNAME_KEYNAME, global_UserName);
        global_LoginMessage.UserName = global_UserName;
        sendToServer({ Login : global_LoginMessage });
      });
    });
    install_just_once('use-compass-checkbox', checkbox => {
      checkbox.addEventListener('change', () => {
        global_IsCompassEnabled = checkbox.checked;
        localStorage.setItem(ISCOMPASSENABLED_KEYNAME, global_IsCompassEnabled);
      });
    });
    
    install_just_once('compasspatch-reverse-checkbox', checkbox => {
      checkbox.addEventListener('change', () => {
        global_CompassPatchReverse = checkbox.checked;
        localStorage.setItem(COMPASSPATCH_REVERSE_KEYNAME, global_CompassPatchReverse);
      });
    });
    
    install_just_once('compasspatch-offset', textbox => {
      textbox.addEventListener('change', () => {
        let new_offset = parseFloat(textbox.value);
        if (!isNaN(new_offset)) {
          global_CompassPatchOffsetDeg = normalize_deg_to_positive(new_offset);
          localStorage.setItem(COMPASSPATCH_OFFSET_KEYNAME, new_offset);
        }
      });
    });
    
    install_just_once('info-devtable-clear-button', button => {
      button.addEventListener('click', () => {
        devtable_compass_fixes_backup = [...devtable_compass_fixes];
        // devtable_clear(); 
        global_IsDeviationTableEnabled = true;
        devtable_show();
        openlayers_attributions_button.dispatchEvent(new Event('click'));
      });
    });
  }
});

let global_ServerConnection = null;

function scaleGeometry2(ng, scale_x, scale_y) {
  const fc = ng.flatCoordinates; // Simple ng.scale(scale) distorts the image. The simplified version works, too.
  for (let i=0; i<fc.length; ) {
    // The ng.getCoordinates / ng.setCoordinates is more complicated than direct access to flatCoordinates.
    fc[i] *= scale_x;
    ++i;
    fc[i] *= scale_y;
    ++i;
  }
}

function scaleGeometry(ng, scale) {
  const fc = ng.flatCoordinates; // Simple ng.scale(scale) distorts the image. The simplified version works, too.
  for (let i=0; i<fc.length; ++i) {
    // The ng.getCoordinates / ng.setCoordinates is more complicated than direct access to flatCoordinates.
    fc[i] *= scale;
  }
}

function svg_group_and_path_for_plot(parentSvg, classnames, color)
{
  const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
  g.setAttribute("transform", SVG_DEFAULT_TRANSFORM);
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", "M0 0 L20 0");
  const real_color = color ? color : "red";
  path.setAttribute("style", `fill:none;stroke:${real_color};`);
  path.setAttribute("class", classnames);
  g.appendChild(path);
  parentSvg.appendChild(g);
  return path;
}

function plot_svg_path(svgPath, flatCoordinates)
{
  if (!flatCoordinates) {
    return;
  }

  if (flatCoordinates.length < 2) {
    svgPath.setAttribute("d", "");
    return;
  }

  let spath = `M${flatCoordinates[0]} ${flatCoordinates[1]}`;
  for (let i=2; i<flatCoordinates.length;) {
    const pt_x = flatCoordinates[i];
    ++i;
    const pt_y = flatCoordinates[i];
    ++i;
    spath = `${spath} L${pt_x} ${pt_y}`;
  }
  svgPath.setAttribute("d", spath);
}

function depth_profile_average_depth(vessel, plot_x)
{
  const FALLBACK_DEPTH = -10;
  if (!vessel.DepthProfiles) {
    console.log("depth_profile_average_depth: no depthi profiles found.");
    return FALLBACK_DEPTH;
  }

  let depth_sum = 0;
  let depth_count = 0;

  let edges_sum = 0;
  let edges_count = 0;

  for (let profileName in vessel.DepthProfiles) {
    const dpo = vessel.DepthProfiles[profileName];
    if (!dpo) {
      continue;
    }
    const dp = dpo.DepthProfile;
    if (!dp || dp.length<4) {
      continue;
    }

    edges_sum += dp[1] + dp[dp.length-1];
    edges_count += 2;

    let x0 = dp[0];
    for (let i=2; i<dp.length; i += 2) {
      const x1 = dp[i];
      if (x0 <= plot_x && plot_x <= x1) {
        depth_sum += dp[i-1] + dp[i+1];
        depth_count += 2;
        break;
      }
      x0 = x1;
    }
  }

  if (depth_count > 0) {
    const r = depth_sum / depth_count;
    return r;
  }
  if (edges_count > 0) {
    const r = edges_sum / edges_count;
    console.log(`depth_profile_average_depth: using edges, r=${r}m`);
    return r;
  }
  console.log("depth_profile_average_depth: no depth found.");
  return FALLBACK_DEPTH;
}

const CRANE_PLOT_LINE_WIDTH = 0.3;
const CRANE_ZOOMPLOT_LINE_WIDTH = CRANE_PLOT_LINE_WIDTH / 4;

function redrawAllShips() {

  const CRANE_END_SHORT = 0; // 1.1597; // 54.8795m from the beginning
  const CRANE_END_DEPTH = 0.7; // 1.5;
  const CRANE_END_RADIUS = 0.0; // 0.5;

  for (let vesselName in global_Vessels) {
    const vessel = global_Vessels[vesselName];
    let crane_extra_x = 0;

    // Any special on the part?
    if (vessel.PartsCrane
          && 'Crane-Frame' in vessel.Parts
          && 'Crane-End' in vessel.Parts
          && 'Crane-Begin' in vessel.Parts) {
      const p1 = vessel.Parts['Crane-Frame'];
      const p2 = vessel.Parts['Crane-End'];
      const p3 = vessel.Parts['Crane-Begin'];
      if (p1 && p2 && p3) {
        const loc1 = p1.Location;
        const loc2 = p2.Location;
        const loc3 = p3.Location;

        if (loc1 && loc2 && ('Altitude' in p1) && ('Altitude' in p2)) {
          const pt1 = global_ProjectTransform.forward(loc1);
          const pt2 = global_ProjectTransform.forward(loc2);
          const pt3 = global_ProjectTransform.forward(loc3);
          crane_extra_x = distance(pt1, pt3);

          const crane_width = distance(pt3, pt2);
          const crane_height = p2.Altitude - p1.Altitude;
          const crane_length = Math.sqrt(crane_width*crane_width + crane_height*crane_height);
          const plot_x = distance(pt1, pt2) - (CRANE_END_SHORT/crane_length)*crane_width + (CRANE_END_DEPTH/crane_length)*crane_height + CRANE_END_RADIUS;

          // 1. Main vline.
          if (!ui_crane_vline_svg) {
            ui_crane_vline_svg = svg_group_and_path_for_plot(ui_crane_svg, "svg-normalpath", "gray");
          }
          plot_svg_path(ui_crane_vline_svg, [plot_x, p2.Altitude, plot_x, -20]);

          // 2. Zoom vline.
          if (!ui_cranezoom_vline_svg) {
            ui_cranezoom_vline_svg = svg_group_and_path_for_plot(ui_cranezoom_svg_group, "svg-zoompath", "gray");
          }
          plot_svg_path(ui_cranezoom_vline_svg, [plot_x, crane_height, plot_x, -20]);

          const plot_y = depth_profile_average_depth(vessel, plot_x);
          ui_cranezoom_svg_group.setAttribute("transform", `translate(${-plot_x} ${plot_y})`); // y retains sign, becaue it is already mirrored.
        }
      }

      const vessel_status = vessel.Status;
      if (vessel_status) {
        ui_crane_status_svg.textContent = vessel_status;
      }
    }

    const nullpoint = [0, 0];
    for (let partName in vessel.Parts) {
      const part = vessel.Parts[partName];
      // Heading.
      let heading = part.Heading;
      if (!heading) {
        heading = 0;
        try {
          const tf_all = vessel.TrackFeatures;
          if (tf_all) {
            const tf0 = tf_all[tf_all.length-1];
            const g = tf0.getGeometry();
            const fc = g.flatCoordinates;
            if (fc.length>4) {
              const fc_dx = fc[fc.length-2] - fc[fc.length-4];
              const fc_dy = fc[fc.length-1] - fc[fc.length-3];
              let course_rad = Math.atan2(fc_dx, fc_dy);
              heading = normalize_deg_to_positive(rad2deg * course_rad);
            }
          }
        } catch (ex) {
          console.log(`Heading problem: ${ex}`)
        }
      }
      const features = part.Features;
      const geometries = part.Geometries;
      const offset_x = 'OffsetX' in part ? part.OffsetX : 0;
      const offset_y = 'OffsetY' in part ? part.OffsetY : 0;
      if (features && geometries) {
        const length = features.length;
        const ar = -heading * deg2rad;
        const vph_location = part.Location ? part.Location : vessel.Position;
        if (!vph_location || vph_location.length<2) {
          continue;
        }
        const scale = LonLatToScale(vph_location);
        const pos_real = fromLonLat(vph_location);
        let cos_tilt = 1;
        const vph_altitude = 'Altitude' in part ? part.Altitude : 0;
        if (part.EnableTilt && 'Tilt' in part) {
          cos_tilt = Math.cos(part.Tilt * deg2rad);
          set_crane_crane_tilt(part.Tilt, crane_extra_x, -vph_altitude); // y is flipped, thus - translate.
        }
        for (let i=0; i<length; ++i) {
          const ng = geometries[i].clone();
          if (offset_x || offset_y) {
            ng.translate(offset_x, offset_y);
          }
          scaleGeometry2(ng, scale, cos_tilt * scale);
          ng.rotate(ar, nullpoint);
          ng.translate(pos_real[0], pos_real[1]);
          features[i].setGeometry(ng);
        }
      }
    }

    if (vessel.DepthProfiles) {
      for (let profileName in vessel.DepthProfiles) {
        const dp = vessel.DepthProfiles[profileName];
        // 1. Main profile
        let ubp = ui_bottom_paths[profileName];
        if (!ubp) {
          ubp = svg_group_and_path_for_plot(ui_crane_svg, "svg-normalpath", dp.DepthProfileColor);
          ui_bottom_paths[profileName] = ubp;
        }
        plot_svg_path(ubp, dp.DepthProfile);

        // Zoom profile.
        let ubp2 = ui_bottomzoom_paths[profileName];
        if (!ubp2) {
          ubp2 = svg_group_and_path_for_plot(ui_cranezoom_svg_group, "svg-zoompath", dp.DepthProfileColor);
          ui_bottomzoom_paths[profileName] = ubp2;
        }
        plot_svg_path(ubp2, dp.DepthProfile);

      }
    }

    const pos_vessel = vessel.Position;
    if (!pos_vessel) {
      continue;
    }

    const draw_arrow_if_needed = function(bearing, prop_name, style) {
      if (bearing) {
        if (!vessel[prop_name]) {
          vessel[prop_name] = new Feature({
            geometry: new LineString([[0, 0], [0, 0]]),
          });
          vessel[prop_name].set('style', style);
          global_VesselsTracksSource.addFeature(vessel[prop_name]);
        }
        const bearing_line = coordinates_for_arrow(pos_vessel, bearing, 40.0);
        vessel[prop_name].setGeometry(new LineString(bearing_line));
      }
    }
    draw_arrow_if_needed(vessel.BearingFromOriginDeg, "debug_bearing_from_origin", FS.AutopilotDebugArrowStyle);
    draw_arrow_if_needed(vessel.BearingFromPositionDeg, "debug_bearing_from_position", FS.AutopilotArrowStyle);
  }
}

function addGeotag(id, geotag) {
  const feature = new Feature({
    geometry: new Point(fromLonLat(geotag.Location)),
  });
  feature.setId(id);
  feature.geotagName = id;
  global_GeotagsSource.addFeature(feature);
  global_Geotags[id] = geotag;
}

function processAddRock(positionMessage) {
  /*
  const features = global_RockMuster.map(f => f.clone());
  const loc_webmercator = fromLonLat(positionMessage.Location);
  const loc_x = loc_webmercator[0];
  const loc_y = loc_webmercator[1];
  const scale = LonLatToScale(positionMessage.Location);
  for (let i=0; i<features.length; ++i) {
    const feature = features[i];
    const ng = feature.getGeometry();
    scaleGeometry(ng, scale);
    ng.translate(loc_x, loc_y);
    feature.set('depth', positionMessage.Z);
  }
  global_Rocks.push({ location:loc_webmercator, features:features });
  global_RocksSource.addFeatures(features);
  */
  const loc_webmercator = fromLonLat(positionMessage.Location);
  const features = addFeaturesToSource(global_RocksSource, global_RockMuster.map(f => f.clone()), positionMessage.Location, (feature) => { feature.set('depth', positionMessage.Z); });
  global_Rocks.push({ location:fromLonLat(positionMessage.Location), features:features });
}

function processDeleteRock(positionMessage) {
  const c = fromLonLat(positionMessage.Location);
  let best_index = -1;
  let best_distance = null; 
  let best_coordinate = null;
  let best_features = null;
  for (let i=0; i<global_Rocks.length; ++i) {
    const rock = global_Rocks[i];
    const d = distance(c, rock.location);
    if (best_index<0 || d<best_distance) {
      best_distance = d;
      best_index = i;
      best_coordinate = rock.location;
      best_features = rock.features;
    }
  }
  if (best_index<0) {
    return;
  }
  consolelog('processDeleteRock');
  for (let fi=0; fi<best_features.length; ++fi) {
    global_RocksSource.removeFeature(best_features[fi]);
  }
  global_Rocks.splice(best_index, 1);
}

function processDeleteAllRocks() {
  if (global_Rocks && global_Rocks.length>0) {
    global_Rocks.splice(0, global_Rocks.length);
  }
  global_RocksSource.clear();
}

function processVesselAutopilotDestination(vesselName, destination_lon_lat, start_lon_lat) {
  if (vesselName in global_Vessels) {
    const vessel = global_Vessels[vesselName];

    const p1= fromLonLat(destination_lon_lat);
    const p0= fromLonLat(start_lon_lat);

    if (!vessel.autopilot_arrow_target) {
      vessel.autopilot_arrow_target = new Feature({
        geometry: new Point([0, 0]),
      });
      vessel.autopilot_arrow_target.set('style', FS.AutopilotTargetDotStyle);
      global_VesselsTracksSource.addFeature(vessel.autopilot_arrow_target);
    }
    vessel.autopilot_arrow_target.setGeometry(new Point(p1));

    if (!vessel.autopilot_arrow) {
      vessel.autopilot_arrow = new Feature({
        geometry: new LineString([[0, 0], [0, 0]]),
      });
      vessel.autopilot_arrow.set('style', FS.AutopilotArrowStyle);
      global_VesselsTracksSource.addFeature(vessel.autopilot_arrow);
    }
    vessel.autopilot_arrow.setGeometry(new LineString([p0, p1]));
  }
}

function processVesselDebugAutopilotStartDestination(vesselName, destination_lon_lat, start_lon_lat, real_start_lon_lat) {
  if (vesselName in global_Vessels) {
    const vessel = global_Vessels[vesselName];

    const p1= fromLonLat(destination_lon_lat);
    const p0= fromLonLat(start_lon_lat);
    const p00= fromLonLat(real_start_lon_lat);

    if (!vessel.debug_autopilot_arrow_target) {
      vessel.debug_autopilot_arrow_target = new Feature({
        geometry: new Point([0, 0]),
      });
      vessel.debug_autopilot_arrow_target.set('style', FS.AutopilotDebugTargetDotStyle);
      global_VesselsTracksSource.addFeature(vessel.debug_autopilot_arrow_target);
    }
    vessel.debug_autopilot_arrow_target.setGeometry(new Point(p0));

    if (!vessel.debug_autopilot_arrow) {
      vessel.debug_autopilot_arrow = new Feature({
        geometry: new LineString([[0, 0], [0, 0]]),
      });
      vessel.debug_autopilot_arrow.set('style', FS.AutopilotDebugArrowStyle);
      global_VesselsTracksSource.addFeature(vessel.debug_autopilot_arrow);
    }
    vessel.debug_autopilot_arrow.setGeometry(new LineString([p00, p0, p1]));
  }
}

function processVesselAutopilotTrack(vesselName, datasetVersion) {
  if (vesselName in global_Vessels) {
    const vessel = global_Vessels[vesselName];

    fetch_geojson(`./${global_dir}/Vessel/${vesselName}/autopilot_track.geojson?v=${datasetVersion}`, function(features) {
      const old_features = vessel.autopilot_track_features;
      vessel.autopilot_track_features = [];
      if (old_features && old_features.length>0) {
        for (let i=0; i<old_features.length; ++i) {
          global_VesselsTracksSource.removeFeature(old_features[i]);
        }
      }
      for (let i=0; i<features.length; ++i) {
        const f = features[i];
        f.vesselName = vesselName;
        f.set('style', FS.AutopilotTrackStyle);
      }
      vessel.autopilot_track_features = features;
      global_VesselsTracksSource.addFeatures(features);
    });
  }
}

const global_RedrawAllVesselRequests = [];
const global_ShowVesselInfoRequests = [];
const global_SetCenterRequests = [];
const global_AppendTrackCoordinateRequests = [];

let global_LastVesselAutopilotStart = [];

let global_LastCraneWorkPosition = null;
let global_LastCraneBeginPosition = null;
let global_LastCraneVesselPosition = null;


function processVesselMessageIfAny(message, newRequest) {
  let should_redraw_vessel = false;
  let info_for_vessel_name = null;
  const now = new Date();

  const vp = message.VesselPosition;
  if (vp) {
    const vessel = global_Vessels[vp.Name];
    if (vessel) {
      should_redraw_vessel = true;
      const loc = vp.Location;
      if (loc) {
        if (is_position_ok(loc)) {
          should_redraw_vessel = true;
          vessel.Position = vp.Location;
          let tf = vessel.TrackFeatures;
          const has_tf = tf && tf.length>0;
          if (!has_tf) {
            tf = ST.createTrackLogFeatures(vp.Name);
            vessel.TrackFeatures = tf;
            global_VesselsTracksSource.addFeatures(tf);
          }
          global_AppendTrackCoordinateRequests.push({
            vesselName: vp.Name,
            webLocation: fromLonLat(loc)
          });
        }
        else {
          consolelog(`Vessel ${vp.Name} Bad position ${loc}`);
        }
      }
      if ('SpeedKnots' in vp) {
        vessel.SpeedKnots = vp.SpeedKnots;
      }
      if ('TrackDeg' in vp) {
        vessel.TrackDeg = vp.TrackDeg;
      }
      const status = vp.Status;
      if (status) {
        vessel.Status = vp.Status;
        var status_time_net_utc = vp.StatusTimeNetUtc;
        if (status_time_net_utc) {
          vessel.StatusTime = ST.getDateFromTicksNetUtc(status_time_net_utc);
        }
        else {
          delete vessel.StatusTime;
        }
      }
      if ('PositionKm' in vp) {
        vessel.Pk = vp.PositionKm * 10;
      }

      info_for_vessel_name = vp.Name;
      if (global_VesselNameToTrack == vp.Name) {
        set_ui_center_by_vessel(vessel);
      }
    }
  }

  const vph = message.VesselPartHeading;
  if (vph) {
    const vessel = global_Vessels[vph.VesselName];
    if (vessel) {
      should_redraw_vessel = true;
      if (vph.Name in vessel.Parts) {
        const part = vessel.Parts[vph.Name];
        if ('Heading' in vph) {
          part.Heading = vph.Heading;
        }
        if ('Tilt' in vph) {
          part.Tilt = vph.Tilt;
        }
        if ('Altitude' in vph) {
          part.Altitude = vph.Altitude;
        }
        if ('DepthProfile' in vph) {
          part.DepthProfile = vph.DepthProfile;
        }
        if ('DepthProfileColor' in vph) {
          part.DepthProfileColor = vph.DepthProfileColor;
        }
        const vph_location = vph.Location;
        if (vph_location) {
          part.Location = vph_location;
          let local_location = fromLonLat(vph_location);
          if (part.TrackEnabled) {
            if (part.TrackFeature) {
              part.TrackFeature.getGeometry().appendCoordinate(local_location);
              part.TrackFeature.changed();
            }
            else {
              part.TrackFeature = new Feature({
                geometry: new LineString([local_location])
              });
              part.TrackFeature.set('vesselName', vph.VesselName);
              global_VesselsTracksSource.addFeature(part.TrackFeature);
            }
          }
        }
        if ('Altitude' in vph) {
          part.Altitude = vph.Altitude;
        }
        if (vessel.Model === VESSEL_MODEL_CRANE) {
          if (vph.Name == "Crane-Work" && vph.Location && 'Heading' in vph) {
            global_LastCraneWorkPosition = vph;
          }
          if (vph.Name == "Crane-Begin") {
            global_LastCraneBeginPosition = vph;
          }
          if (vph.Name == "Vessel") {
            global_LastCraneVesselPosition = vph;
          }
        }
        part.LastActiveTime = now;
        if (vph.Name === vessel.BackupPositionPartName && !vessel.Position && vph_location) {
          set_ui_center_by_vessel(vessel);
        }
      }
      if (vph.VesselName && vph.VesselName == global_VesselNameToTrack) {
        global_ShowVesselInfoRequests.push(vph.VesselName);
      }
    }
  }

  const vdp = message.VesselDepthProfile;
  if (vdp) {
    const vessel = global_Vessels[vdp.VesselName];
    if (vessel) {
      if (!vessel.DepthProfiles) {
        vessel.DepthProfiles = {};
      }
      vessel.DepthProfiles[vdp.Name] = vdp;
      vdp.LastActiveTime = now;
      if (vdp.VesselName && vdp.VesselName == global_VesselNameToTrack) {
        global_ShowVesselInfoRequests.push(vdp.VesselName);
      }
    }
  }

  // Process the WebUser messages, too.
  const webuser_positions = message.WebUserPosition;
  if (webuser_positions) {
    for (let id in webuser_positions) {
      // Process locations.
      let msg = webuser_positions[id];
      if (!msg.Location) {
        continue;
      }
      if (!(id in global_WebUsers)) {
        let features = [new Feature({ geometry: new Point([0, 0])}) ];
        features.forEach(feature => {
          feature.set('vesselType', 'webuser');
          if (msg.Name) {
            feature.set('Name', msg.Name);
          }
        });
        let new_webuser = {
          Features : features,
          Geometries : features.map(f => f.getGeometry().clone()),
        };
        global_WebUsers[id] = new_webuser;
        global_VesselsSource.addFeatures(features);
      }
      let webuser = global_WebUsers[id];
      let new_location = fromLonLat(msg.Location);
      webuser.Features.forEach(feature => {
        feature.setGeometry(new Point(new_location));
        feature.changed();
      });
    }
  }

  const vessel_autopilot_track_updated = message.VesselAutopilotTrackUpdated;
  if (vessel_autopilot_track_updated && vessel_autopilot_track_updated in global_Vessels) {
    processVesselAutopilotTrack(vessel_autopilot_track_updated, getNextDatasetVersion());
  }

  const vessel_autopilot_track_points = message.VesselAutopilotTrackPoints;
  if (vessel_autopilot_track_points && vessel_autopilot_track_updated in global_Vessels) {
    // FIXME: do what?
  }

  const vessel_autopilot_state = message.VesselAutopilotState;
  if (vessel_autopilot_state
    && vessel_autopilot_state.Name
    && vessel_autopilot_state.AutopilotDestination
    && vessel_autopilot_state.AutopilotStart) {
    processVesselAutopilotDestination(vessel_autopilot_state.Name, vessel_autopilot_state.AutopilotDestination, vessel_autopilot_state.AutopilotStart);
    global_LastVesselAutopilotStart = vessel_autopilot_state.AutopilotStart;
  }

  if (vessel_autopilot_state
    && vessel_autopilot_state.Name
    && vessel_autopilot_state.DebugStart
    && vessel_autopilot_state.DebugDestination
    && global_LastVesselAutopilotStart.length>0) {
    processVesselDebugAutopilotStartDestination(vessel_autopilot_state.Name, vessel_autopilot_state.DebugDestination, vessel_autopilot_state.DebugStart, global_LastVesselAutopilotStart);
  }

  if (vessel_autopilot_state
    && vessel_autopilot_state.Name
    && vessel_autopilot_state.DebugBearingFromOriginDeg
    && vessel_autopilot_state.DebugBearingFromPositionDeg) {
      const vesselName = vessel_autopilot_state.Name;
      if (vesselName in global_Vessels) {
        const vessel = global_Vessels[vesselName];
        vessel.BearingFromOriginDeg = vessel_autopilot_state.DebugBearingFromOriginDeg;
        vessel.BearingFromPositionDeg = vessel_autopilot_state.DebugBearingFromPositionDeg;
        // Vessel will be redrawn on next GPS
      }
  }

  if (should_redraw_vessel) {
    global_RedrawAllVesselRequests.push(Date.now())
  }
  if (info_for_vessel_name) {
    global_ShowVesselInfoRequests.push(info_for_vessel_name);
  }
}

function hide_vessel_part(features)
{
  features.forEach((feature,i) => feature.set('style', FS.VectorOverlayStylesNone));
}

function show_vessel_part(features)
{
  features.forEach((feature,i) => feature.unset('style'));
}


function redrawTimerTick() {
  const VISIBILITY_TIMEOUT_MS = 5 * 60 * 1000; // Time for the vessel part or depth profile to disappear when no new data coming.
  const now = new Date();
  let should_redraw_vessel = false;

  // Do the AutoHide feature.
  for (let vesselName in global_Vessels) {
    const vessel = global_Vessels[vesselName];
    const vessel_parts = vessel.Parts;
    if (vessel_parts) {
      // Vessel parts.
      for (let partName in vessel_parts) {
        const part = vessel_parts[partName];
        if (!(part.AutoHide === true)) {
          continue;
        }
        const features = part.Features;
        if (!features) {
          continue;
        }
        let was_visible = true;
        for (let i_feature=0; i_feature<features.length; ++i_feature) {
          const f = features[i_feature];
          const style = f.get('style');
          if (style) {
            was_visible = false;
            break;
          }
        }
        const last_active_time = part.LastActiveTime;
        if (!last_active_time) {
          should_redraw_vessel = should_redraw_vessel || was_visible;
          hide_vessel_part(features);
          continue;
        }
        const dt = now - last_active_time;
        if (dt > VISIBILITY_TIMEOUT_MS) {
          should_redraw_vessel = should_redraw_vessel || was_visible;
          hide_vessel_part(features);
        }
        else {
          should_redraw_vessel = should_redraw_vessel || !was_visible;
          show_vessel_part(features);
        }
      }
    }

    // Depth profiles.
    if (vessel.DepthProfiles) {
      for (let profileName in vessel.DepthProfiles) {
        const dp = vessel.DepthProfiles[profileName];
        const was_visible = dp.DepthProfile.length > 0;
        const last_active_time = dp.LastActiveTime;
        const dt = now - last_active_time;
        if (dt > VISIBILITY_TIMEOUT_MS) {
          should_redraw_vessel = should_redraw_vessel || was_visible;
          dp.DepthProfile = [];
        }
      }
    }
  }

  while (global_AppendTrackCoordinateRequests.length>0) {
    const rq = global_AppendTrackCoordinateRequests.shift();
    if (rq.vesselName && rq.webLocation) {
      const vessel = global_Vessels[rq.vesselName];
      let tf = vessel.TrackFeatures;
      if (tf) {
        const last_track = tf[tf.length-1];
        last_track.trackVesselName = rq.vesselName;
        const last_geometry = last_track.getGeometry();
        last_geometry.appendCoordinate(rq.webLocation);
      }
    }
  }

  while (global_RedrawAllVesselRequests.length>0) {
    global_RedrawAllVesselRequests.shift();
    should_redraw_vessel = true;
  }

  let info_for_vessel_name = null;
  while (global_ShowVesselInfoRequests.length>0) {
    const vn = global_ShowVesselInfoRequests.shift();
    if (vn && vn==global_VesselNameToTrack) {
      info_for_vessel_name = vn;
    }
  }

  let pos_webmercator = null;
  while (global_SetCenterRequests.length>0) {
    pos_webmercator = global_SetCenterRequests.shift();
  }

  if (should_redraw_vessel) {
    redrawAllShips();
  }
  if (info_for_vessel_name) {
    showVesselInfo(info_for_vessel_name);
  }
  if (pos_webmercator) {
    global_View.setCenter(pos_webmercator);
  }

  window.setTimeout(redrawTimerTick, 250);
}

window.setTimeout(redrawTimerTick, 3000);

function processRockMessageIfAny(message, newRequest) {
  const all_rocks = message.ListAllRocks;
  if (all_rocks) {
    processDeleteAllRocks();
    for (let i=0; i<all_rocks.length; ++i) {
      processAddRock(all_rocks[i]);
    }
  }
  const add_rock = message.AddRock;
  if (add_rock) {
    processAddRock(add_rock);
  }
  const delete_rock = message.DeleteRock;
  if (delete_rock) {
    processDeleteRock(delete_rock);
  }
}

function processGeotagMessageIfAny(message, newRequest) {
  const add_geotag = message.AddGeotag;
  if (add_geotag) {
    addGeotag(add_geotag.Key, add_geotag.Value);
  }

  const delete_geotag = message.DeleteGeotag;
  if (delete_geotag && delete_geotag in global_Geotags) {
    global_Info.innerText = '';
    disableGlobalInfo();
    const geotag = global_Geotags[delete_geotag];
    delete global_Geotags[delete_geotag];
    const feature = global_GeotagsSource.getFeatureById(delete_geotag);
    global_GeotagsSource.removeFeature(feature);
  }

  const change_geotag = message.ChangeGeotag;
  if (change_geotag) {
    const key = change_geotag.Key;
    const changes = change_geotag.Value;
    const geotag = global_Geotags[key];
    if (changes && geotag) {
      if (!(changes.Description === undefined || changes.Description==null)) {
        geotag.Description = changes.Description;
      }
      if (!(changes.VideoLinks === undefined || changes.VideoLinks==null)) {
        geotag.VideoLinks = changes.VideoLinks;
      }
      if (!(changes.Category === undefined || changes.Category==null)) {
        geotag.Category = changes.Category;
      }
      if (!(changes.Location === undefined || changes.Location==null)) {
        const feature = global_GeotagsSource.getFeatureById(key);
        const loc = fromLonLat(changes.Location);
        feature.setGeometry(new Point(loc));
        geotag.Location = changes.Location;
      }
      showGeotagInfo(key);
    }
  }

  const uploadimage_geotag = message.UploadImageToGeotag;
  if (uploadimage_geotag) {
    const key = uploadimage_geotag.Key;
    const new_filename = uploadimage_geotag.Value;
    const geotag = global_Geotags[key];
    if (geotag && new_filename) {
      if (!geotag.Files) {
        geotag.Files = [];
      }
      geotag.Files.push(new_filename);
      showGeotagInfo(key);
    }
  }
}

function processUploadXYZFileIfAny(message, newRequest)
{
  const upload_xyz_file = message.UploadXYZFile;
  if (typeof(upload_xyz_file) != "undefined") {
    if (upload_xyz_file) {
      alert(upload_xyz_file);
    }
    else {
      alert("File uploaded successfully!");
    }
  }
}

function processReceiveMessageIfAny(message, newRequest)
{
  const receive_message = message.ReceiveMessage;
  if (receive_message) {
    const target = receive_message.Target;
    if (target && target == subscription_place_mark) {
      const data = receive_message.Data;
      processPlaceMarkMessage(data);
    }
  }
}

// -----------------------------------------------------------------------------
// Websocket reconnection.
websocketcomm.addJsonListener(processVesselMessageIfAny);
websocketcomm.addJsonListener(processRockMessageIfAny);
websocketcomm.addJsonListener(processGeotagMessageIfAny);
websocketcomm.addJsonListener(processUploadXYZFileIfAny);
websocketcomm.addJsonListener(processReceiveMessageIfAny);
websocketcomm.addEventListener('open', () => global_Connected.innerText = 'CONNECTED' );
websocketcomm.addEventListener('close', () => global_Connected.innerText = 'NOT CONNECTED' );
window.setTimeout(() => websocketcomm.reconnect(), 1*1000);
// -----------------------------------------------------------------------------

// sleep time expects milliseconds
function sleep_async (time_ms) {
  return new Promise((resolve) => setTimeout(resolve, time_ms));
}

function svg_group_of_geojson(geojson)
{
  const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
  const features = geojson.features;
  for (let i_feature=0; i_feature<features.length; ++i_feature) {
    // assuming everything is a line.
    const f = features[i_feature];
    const cv = f.geometry.coordinates;
    if (cv.length < 2) {
      continue;
    }
    const p0 = cv[0];
    let spath = `M${p0[0]} ${p0[1]}`;
    for (let i=1; i<cv.length; ++i) {
      const p = cv[i];
      spath = spath + ` L${p[0]} ${p[1]}`;
    }
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", spath);
    path.setAttribute("style", "fill:none;stroke:red;stroke-width:0.3");
    g.appendChild(path);
  }
  return g;
}

try {
  const WGS84 = "EPSG:4326";
  const accept_json_headers = { headers: { Accept: "application/json" } };
  const r_project = await fetch(`./${global_dir}/project.json?v=${global_DatasetVersion}`, accept_json_headers);
  const project = await r_project.json();
  const now = new Date();
  const history_start = new Date(now.getTime() - global_VesselTrackLengthHours * (3600 * 1000));
  global_Project = project;
  const project_transform = "Transform" in project ? project.Transform : "EPSG:3301"; // EPSG:3301 = Lambert-Est 1997
  try {
    global_ProjectTransform = proj4("EPSG:4326", project_transform);
  }
  catch (tex) {
    consolelog(`Cannot load transform '${project_transform}, because: ${tex}`);
  }
  const project_problem = project.Problem;
  if (project_problem) {
    const pm = project_problem.Message;
    if (pm && pm.length>0) {
      enable_control_with_opacity(global_Problem, 0.5);
      global_Problem.innerHTML = pm;
      const pfs = project_problem.FontSize;
      if (pfs && pfs.length>0) {
        global_Problem.style.fontSize = pfs;
      }
    }
  }

  if ('Vessels' in project) {
    global_Vessels = project.Vessels;
    for (let vesselName in global_Vessels) {
      const vessel = global_Vessels[vesselName];
      vessel.Position = null;
      for (let partName in vessel.Parts) {
        const part = vessel.Parts[partName];
        delete part.Features;
        delete part.Geometries;
        delete part.Heading;
        delete part.Tilt;
        if (part.GeojsonFile) {
          const url = `./${global_dir}/${part.GeojsonFile}?v=${global_DatasetVersion}`;
          try {
            const r_part = await fetch(url, accept_json_headers);
            const json = await r_part.json();
            const features = (new GeoJSON()).readFeatures(json);
            for (let i=0; i<features.length; ++i) {
              features[i].vesselName = vesselName;
            }
            global_VesselsSource.addFeatures(features);
            part.Features = features;
            part.Geometries = features.map(f => f.getGeometry().clone());
          }
          catch (ex) {
            console.log(`Cannot fetch ${url}, because: ${ex}`);
          }
        }
      }

      const vessel_crane_parts = vessel.PartsCrane;
      if (vessel_crane_parts) {
        for (let cp_name in vessel_crane_parts) {
          const cpart = vessel_crane_parts[cp_name];
          const url = `./${global_dir}/${cpart.GeojsonFile}?v=${global_DatasetVersion}`;
          try {
            const r_query = await fetch(url, accept_json_headers);
            const json = await r_query.json();
            const g = svg_group_of_geojson(json);
            ui_crane_crane_svg = g;
            set_crane_crane_tilt(0, 0, 0);
            ui_crane_svg.appendChild(g);
          } catch (ex) {
            console.log(`Cannot fetch ${url}, because: ${ex}`);
          }
        }
      }

      // Vessel track feature.
      try {
        const tf = await ST.fetchTrackLogFeatures(`./${global_dir}/Vessel/${vesselName}/Log/`, vesselName, Object.keys(vessel.Parts), global_DatasetVersion, fromLonLat, history_start, now);
        if (tf && tf.length>0) {
          vessel.TrackFeatures = tf;
          global_VesselsTracksSource.addFeatures(tf);
        }
      }
      catch (error) {
        console.log(`Cannot fetch log for ${vesselName} because: ${error}`)
      }

      processVesselAutopilotTrack(vesselName, global_DatasetVersion);
    }
  }
  let project_follow_vessel = project.FollowVessel;
  let should_reload_map = false;

  if (project.IsPrivate) {
    // FIXME: rearrange DTM/DXF
    should_reload_map = true;
  }
  if (project.SurveyType == SURVEYTYPE_LAND) {
    dtmxLayer.setStyle(createLandHeightTextStyle);
    should_reload_map = true;
  }
  var basemap = project.Basemap;
  if (basemap) {
    // FIXME: make it work again.
    // setBasemap(basemap);
  }
  if (should_reload_map) {
    global_DatasetVersion = getNextDatasetVersion();
    reload_layer(dtmxLayer, 'DTMX');
    reload_layer(dtmxLayer, 'TIF');
  }

  // Update the colors of the tasks if needed.
  const styles = project.Styles;
  if (styles) {
    const tasks = styles.Tasks;
    if (tasks) {
      const features = global_VectorOverlaySource.getFeatures();
      for (const rx of Object.keys(tasks)) {
        const rxx = new RegExp(rx, 'i');
        const task_color = tasks[rx].Color;
        if (!task_color) {
          continue;
        }
        for (let i=0; i<features.length; ++i) {
          const f = features[i];
          const filename = f.get('filename');
          if (filename && rxx.test(filename)) {
            console.log('setting color for ' + filename + ' to ' + task_color);
            const type = f.getGeometry().getType();
            if (type == 'Point') {
              f.set('fillColor', task_color);
            }
            else {
              f.set('style', FS.CreateStrokeStyle(task_color));
            }
          }
        }
      }
    }
  }

  // Create the grid lines.
  {
    const ZOOMPLOT_SIZE=2000;
    const real_color = "darkgreen";
    const stroke_width = CRANE_ZOOMPLOT_LINE_WIDTH/2;

    /*
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("style", `fill:none;stroke:${real_color};stroke-width:${stroke_width}`);
    ui_cranezoom_svg_grid.appendChild(path);
    */

    for (let iy=-ZOOMPLOT_SIZE; iy<=ZOOMPLOT_SIZE; iy+=2) {
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("style", `fill:none;stroke:${real_color};`);
      path.setAttribute("class", `svg-zoompath`);
      ui_cranezoom_svg_grid.appendChild(path);
      plot_svg_path(path, [-ZOOMPLOT_SIZE, iy, ZOOMPLOT_SIZE, iy]);
    }
    for (let ix=-ZOOMPLOT_SIZE; ix<=ZOOMPLOT_SIZE; ix+=5) {
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("style", `fill:none;stroke:${real_color};stroke-width`);
      path.setAttribute("class", `svg-zoompath`);
      ui_cranezoom_svg_grid.appendChild(path);
      plot_svg_path(path, [ix, -ZOOMPLOT_SIZE, ix, ZOOMPLOT_SIZE]);
    }
  }

  // Water levels on the crane.
  {
    const PLOT_SIZE = 800;
    const stroke_width = CRANE_PLOT_LINE_WIDTH/2;

    // Main plot.
    const path = svg_group_and_path_for_plot(ui_crane_svg, "svg-normalpath", "darkgray");
    plot_svg_path(path, [-PLOT_SIZE/2, 0, PLOT_SIZE + PLOT_SIZE/2, 0]);
    path.setAttribute("stroke-dasharray", "1,1");

    // Zoom plot....
    const zoompath = svg_group_and_path_for_plot(ui_cranezoom_svg_group, "svg-zoompath", "darkgray");
    plot_svg_path(zoompath, [-PLOT_SIZE, 0, PLOT_SIZE, 0]);
    zoompath.setAttribute("stroke-dasharray", "1,1");
  }

  // Follow a vessel if requested from the URL command line.
  if (global_ParamsFollowVessel) {
    followVesselByName(global_ParamsFollowVessel);
  }
  else if (project_follow_vessel) {
    // Follow a vessel if requested by the project file.
    followVesselByName(project_follow_vessel);
  }
}
catch (ex3) {
  console.log(`Project fetch: ${ex3}`);
}

/*
fetch_json(`./${global_dir}/Rocks.txt`, function (project) {
}
*/

function getXmlText(navmark, tagname) {
  const v = navmark.getElementsByTagName(tagname);
  if (v.length>0) {
    return v[0].textContent;
  }
  return '';
}

let getXmlTextAsNumber = (navmark, tagname) => Number(getXmlText(navmark, tagname));

let getXmlTextAsCoordinate = (navmark, tagname) => Number(getXmlText(navmark, tagname)) * (1e-6 / 60.0);

const replacementMap = [
  { letters:/[\u00dc]/g, base:'u'}, // � &Uuml;
  { letters:/[\u00c4]/g, base:'a'}, // � &Auml;
  { letters:/[\u00d5]/g, base:'o'}, // � &Otilde;
  { letters:/[\u00d6]/g, base:'o'}, // � &Ouml;
  { letters:/[\u00fc]/g, base:'u'}, // � &uuml;
  { letters:/[\u00e4]/g, base:'a'}, // � &auml;
  { letters:/[\u00f5]/g, base:'o'}, // � &otilde;
  { letters:/[\u00f6]/g, base:'o'}, // � &ouml;
  { letters:/[\u00df]/g, base:'ss'},// � &szlig;
  { letters:/\//g, base:'_'}// � &szlig;
];

function correctSeamarkTypename(str) {
  let r = str;
  for(var i=0; i<replacementMap.length; ++i) {
    r = r.replace(replacementMap[i].letters, replacementMap[i].base);
  }
  return r.toLowerCase();
}

async function fetch_seamark(path) {
  return await fetch_geojson_async(path);
}

const global_SeamarksDirectory = MAPDIR_PREFIX + "/seamark";

// Fetch features of the given seamark.
// Returns null on failure.
async function fetchSeamarkFeatures(name) {
  const url = `${global_SeamarksDirectory}/${name}.geojson`;
  try {
    const response = await fetch(url);
    const json = await response.json();
    const features = global_GeoJSON.readFeatures(json);
    return features;
  } catch(error) {
    consolelog('Cannot fetch "' + name + '", because:' + error);
    return null;
  }
}

const fetchSeamarksFeatures = (names, buffer) =>
  Promise.all(names.map(fetchSeamarkFeatures))
    .then(jsons => {
      let r = null;
      if (buffer) {
        r = buffer;
      }
      else {
        r = {};
      }
      for (let i=0; i<names.length; ++i) {
        r[names[i]] = jsons[i];
      }
      return r;
    }, ex => {
      consolelog('Cannot fetch, because:' + ex);
    });

fetch(`${global_SeamarksDirectory}/navimark.xml`, { mode: 'no-cors' })
  .then(response => response.text())
  .then(text => (new window.DOMParser()).parseFromString(text, "text/xml"))
  .then(xml => {
    let navmarks = xml.getElementsByTagName('Navimark');
    let navtypes = ["1", "3", "10", "11", "20"];
    for (let i=0; i<navmarks.length; ++i) {
      let nm = navmarks[i];
      let ni = {
        name: getXmlText(nm, 'Name'),
        estno: getXmlText(nm, 'EstNo'),
        position: [getXmlTextAsCoordinate(nm, 'Longitude'), getXmlTextAsCoordinate(nm, 'Latitude')],
        status: getXmlText(nm, 'Status'),
        type: getXmlText(nm, 'Type'),
        typename: correctSeamarkTypename(getXmlText(nm, 'TypeName')),
        color: getXmlText(nm, 'Colour'),
        colors: getXmlText(nm, 'Colours'),
        features:[]
      };
      // console.log('navmark: ' + name + ': ' + ' lat:' + lat + ' lon:' + lon + ' status:' + status);
      if (ni.status == '0') {
        if (ni.typename.length>0 && !navtypes.includes(ni.typename)) {
          navtypes.push(ni.typename);
        }
        if (ni.type.length>0 && !navtypes.includes(ni.type)) {
          navtypes.push(ni.type);
        }
        global_Seamarks.push(ni);
      }
    }

    fetchSeamarksFeatures(navtypes, global_SeamarkDrawings)
      .then(seamarkdrawings => {
        for (let i=0; i<global_Seamarks.length; ++i) {
          const ni = global_Seamarks[i];
          let f = null;
          if (f==null && ni.typename in seamarkdrawings) {
            f = seamarkdrawings[ni.typename];
          }
          if (f==null && ni.type in seamarkdrawings) {
            f = seamarkdrawings[ni.type];
          }

          // Plot on the screen
          let f2 = f.map(x => x.clone());
          let scale = LonLatToScale(ni.position);
          const pos_webmercator = fromLonLat(ni.position);
          const pos_x = pos_webmercator[0];
          const pos_y = pos_webmercator[1];
          f2.forEach((item, index, array) => {
            item.navigationInfo = ni;
            const ng = item.getGeometry();
            scaleGeometry(ng, 2 * scale); // 2x bigger just to be visible better.
            ng.translate(pos_x, pos_y);
          });
          global_SeamarksSource.addFeatures(f2);
        }
      });
  });

function createText(parent, label, backgroundColor) {
  const text = document.createElement('div');
  text.innerText = label;
  text.style.background = backgroundColor;
  text.style.width = '100%';
  parent.appendChild(text);
  return text;
}

// &v=' + global_DatasetVersion
const task_default_url = `./${global_dir}/Task_default.col&v=${global_DatasetVersion}`;
try {
  const response = await fetch(task_default_url);
  const text = await response.text();
  const ini = ST.parseIniString(text);
  const values = ini['Values'];
  const colors = ini['Colors'];
  if (values && colors) {
    let maxindex = 0;
    for (let i=0; ; ++i) {
      const s = i.toString();
      if (s in values) {
        maxindex = i;
      }
      else {
        break;
      }
    }
    for (let i=maxindex; i>=0; --i) {
      const s = i.toString();
      if (s in values) {
        createText(global_ColorInfo, values[s], `rgb(${colors[s]})`);
      }
    }
    enable_control(global_ColorInfo);
  }
}
catch (ex) {
  consolelog(`Cannot fetch ${task_default_url}, because: ${ex}`);
}

function onWindowResize() {
  const w = global_Map.getSize()[0];
  if (global_ScaleLine) {
    global_Map.removeControl(global_ScaleLine);
  }
  let steps = 8;
  while (steps * 200 < w) {
    steps *= 2;
  }
  global_ScaleLine = new ScaleLine({
    units: 'metric',
    bar: true,
    steps: steps,
    text: true,
    className: 'my-map-scale',
    minWidth: w/3.5,
  });
  global_Map.addControl(global_ScaleLine);
}

// SVG zoom buttons, if any.
{
  const MAX_SVG_SCALE = 4;
  const MIN_SVG_SCALE = 0.15;
  const SVG_VIEWPORT_SIZE = 16;
  const SVG_STROKE_WIDTH = 0.05;

  let svg_zoom_level = 0;

  function onSvgZoomButton(ev, dir)
  {
    const next_zoom_level = svg_zoom_level + 0.25 * dir;
    const factor = Math.exp(next_zoom_level);
    const next_scale = factor;
    if (next_scale > MAX_SVG_SCALE || next_scale<MIN_SVG_SCALE) {
      return;
    }
    svg_zoom_level = next_zoom_level;
    ui_cranezoom_svg_scale.setAttribute("transform", `scale(${next_scale})`);
    const vp_size =  SVG_VIEWPORT_SIZE / factor;
    ui_cranezoom_svg_svg.setAttribute("viewBox", `-${vp_size/2} -${vp_size/2} ${vp_size} ${vp_size}`);

    const gridstyle = get_style_by_selector(".svg-zoompath");
    gridstyle.strokeWidth = SVG_STROKE_WIDTH / (factor * factor);
  }
  document.getElementById("svgzoom-in-button").addEventListener('click', (e) => onSvgZoomButton(e, +1));
  document.getElementById("svgzoom-out-button").addEventListener('click', (e) => onSvgZoomButton(e, -1));
}

function onCraneGeotagCancelButton(ev)
{
  localStorage.setItem(CRANE_BLOCK_HEIGHT_KEYNAME, ui_crane_geotag_height.value);
  localStorage.setItem(CRANE_BLOCK_WIDTH_KEYNAME, ui_crane_geotag_width.value);
  localStorage.setItem(CRANE_BLOCK_LENGTH_KEYNAME, ui_crane_geotag_length.value);
  disable_control(ui_crane_geotag_div);
}

function onCraneGeotagShowButton(ev)
{
  enable_control(ui_crane_geotag_div);
}

// Process the uploaded file by sending it to the server.
function onCraneUploadXyzInputChange(ev)
{
  const files_length = this.files.length;
  if (files_length == 0) {
    return;
  }
  for (let i_files=0; i_files<files_length; ++i_files) {
    const f_i = this.files[i_files];
    const reader = new FileReader();
    reader.onload = function(event) {
      const dataURL = reader.result;
      const base64 = dataURL.slice(dataURL.indexOf(',')+1);
      sendToServer({
        UploadXYZFile: {
          Name: f_i.name,
          Data: base64
        }
      });
    }
    reader.readAsDataURL(f_i);
  }
}

function onCraneUploadXyzButton(ev)
{
  ui_crane_upload_input.click();
}

document.getElementById('geotag-cancel-button').addEventListener('click', onCraneGeotagCancelButton);
if (global_IsOperator) {
  ui_crane_geotag_button.addEventListener('click', onCraneGeotagShowButton);
  ui_crane_upload_button.addEventListener('click', onCraneUploadXyzButton);
  ui_crane_upload_input.addEventListener('change', onCraneUploadXyzInputChange, false);

  ui_crane_geotag_height.value = get_float_or_default(CRANE_BLOCK_HEIGHT_KEYNAME, 2.0);
  ui_crane_geotag_width.value = get_float_or_default(CRANE_BLOCK_WIDTH_KEYNAME, 4.0);
  ui_crane_geotag_length.value = get_float_or_default(CRANE_BLOCK_LENGTH_KEYNAME, 4.0);
}

onWindowResize();
window.addEventListener('resize', onWindowResize);

console.log("Init Done.");
